const en = {
  appTitle: "VoxPop AI",
  appDesc: "Real-time audience engagement",
  startSession: "Start New Q&A Session",
  joinSession: "Join via ID",
  orJoin: "or join existing",
  setupSession: "Setup Session",
  configureChannel: "Configure your Q&A channel",
  sessionTitle: "Session Title",
  descOptional: "Description (Optional)",
  maxQuestions: "Max Questions/User",
  accessControl: "Access Control",
  protected: "Protected",
  public: "Public",
  optional: "Optional",
  requiresPin: "Requires PIN",
  requireLogin: "Require Google login",
  requireLoginDesc: "Audience must sign in with Google before joining.",
  freeToJoin: "Free to join",
  addDescriptionPrompt: "Add a description to help AI understand your context...",
  uploadSlidePrompt: "Upload a slide deck to visually guide your audience...",
  uploadSlideBtn: "Upload Slide Deck",
  optionalEncouragement: "Optional, but recommended for best AI results.",
  cancel: "Cancel",
  close: "Close",
  createChannel: "Create Channel",
  joinTitle: "Welcome!",
  joining: "You're joining",
  yourName: "Your Name",
  leaveBlank: "Leave blank to use",
  joinBtn: "Join Session",
  loginRequiredTitle: "Sign in to join",
  loginRequiredDesc: "This session requires Google sign-in before you can join.",
  continueWithGoogle: "Continue with Google",
  signedInAs: "Signed in as",
  recent: "Recent",
  popular: "Top Voted",
  mine: "My Qs",
  noQuestions: "No questions yet",
  typeQuestion: "Type a question...",
  askingDisabled: "Asking is disabled",
  postAs: "Post as",
  left: "left",
  liveFeed: "Live Feed",
  analytics: "Analytics",
  insights: "AI Insights",
  exportCSV: "Export CSV",
  endSession: "End Session",
  sessionEnded: "Session Ended",
  joinCode: "Join Code",
  showQR: "Show QR",
  trendingTopics: "Trending Topics",
  engagement: "Engagement",
  active: "Active",
  passive: "Passive",
  aiAnalysisReady: "AI Analysis Ready",
  generateInsights: "Generate Live Insights",
  addApiKey: "Add API Key to Enable AI",
  removeApiKeyTitle: "Remove API Key?",
  removeApiKeyConfirm: "AI features will stop working until a new key is saved.",
  removeApiKeyAction: "Remove Key",
  refreshAnalysis: "Refresh Analysis",
  online: "Online",
  activeParticipants: "Active Participants",
  markAnswered: "Mark Answered",
  answered: "Answered",
  hide: "Hide",
  unhide: "Unhide",
  favorite: "Favorite",
  pin: "Pin to Top",
  analyzing: "Analyzing...",
  autoGroup: "Auto-Group Topics",
  checkGrammar: "Suggestion",
  reanalyze: "Re-analyze",
  checking: "Checking...",
  aiSuggestion: "AI Suggestion",
  applyChange: "Apply Change",
  dismiss: "Dismiss",
  questions: "Questions",
  endSessionConfirmTitle: "End Session?",
  endSessionConfirmBody:
    "This will permanently close the session. Participants will be disconnected and no longer able to access it. You will be returned to the home screen.",
  confirmEnd: "Yes, End Session",
  sessionUnavailable: "Session Unavailable",
  createError: "Failed to create session. Please try again.",
  error: "Error",
  sessionEndedMessage: "This Q&A session has ended and is no longer available.",
  backToHome: "Back to Home",
  aiPriorityEx:
    "Score calculated based on grammar, clarity, and topic relevance.",
  presentationMode: "Presentation Mode",
  startPresentation: "Start Presentation",
  presenting: "Presenting",
  noQuestionsFilter: "No questions to present in this filter",
  exitPresentation: "Exit Presentation",
  next: "Next",
  prev: "Previous",
  shortcuts: "Shortcuts",
  markAnsweredShort: "Mark Answered",
  keyboardHint: "Use ← → to navigate, Enter to answer, Esc to exit",

  // Slide Features
  slides: "Slide-Synced",
  uploadSlides: "Upload Slides",
  uploadSlidesDesc:
    "Upload your presentation (images) to group questions by slide.",
  uploadBtn: "Select Images",
  processingSlides: "Processing slides...",
  generalQuestions: "General / Meta",
  currentSlide: "Current Slide",
  setAsCurrent: "Set as Current",
  questionsForSlide: "Questions for Slide",

  // Feedback Mode
  softCloseTitle: "Wrap Up Session?",
  softCloseBody:
    "You can enter 'Feedback Mode' to stop new questions and ask attendees for a rating and key takeaways. Or end immediately.",
  startFeedback: "Start Feedback Mode",
  skipFeedback: "Skip Feedback & End",
  endImmediately: "End Immediately",
  feedbackMode: "Feedback Mode",
  feedbackLive: "Feedback is Live",
  feedbackLocked: "Feedback Locked",
  feedbackLockedDesc:
    "Start feedback mode to allow the audience to rate the session and unlock their Cheat Sheet.",
  startFeedbackMode: "Start Feedback Mode",
  finalResults: "Final results",
  responded: "Responded",
  participantsLabel: "participants",
  liveComments: "Live Comments",
  waitingForComments: "Waiting for comments...",
  noComment: "No comment provided",
  waitingForFeedback: "Waiting for audience feedback...",
  analyzeSentiment: "Analyze sentiment",
  reanalyzeSentiment: "Re-analyze sentiment",
  averageRating: "Average Rating",
  netScore: "Session Score",
  archiveSession: "Archive & Close",
  rateSession: "Rate this Session",
  feedbackPlaceholder: "What was your key takeaway? (Optional)",
  submitFeedback: "Submit Feedback",
  thankYou: "Thank You!",
  aiTakeawayTitle: "Your AI Session Cheat Sheet",
  aiTakeawayDesc:
    "VoxPop analyzed the session and generated this summary for you to keep.",
  generatingTakeaway: "Generating your session summary...",
  generateTakeawayDesc: "Generate a concise summary of slides & Q&A for your audience.",
  generateBtn: "Generate",
  updating: "Updating...",
  copy: "Copy",
  feedbackReport: "Feedback",
  exitSession: "Exit Session",
  remove: "Remove",

  // Support Requests
  supportCenter: "Support",
  supportCenterDesc:
    "Send feature requests or bug reports. Attach files and track status here.",
  requestType: "Request Type",
  requestTypeFeature: "Feature Request",
  requestTypeBug: "Bug Report",
  requestTitle: "Title",
  requestTitlePlaceholder: "Short summary",
  requestDescription: "Details",
  requestDescriptionPlaceholder: "Steps, expected behavior, and context.",
  attachments: "Attachments",
  submitRequest: "Submit Request",
  submitting: "Submitting...",
  requestStatus: "Your Requests",
  noSupportRequests: "No requests submitted yet.",
  supportStatusSubmitted: "Submitted",
  supportStatusInReview: "In review",
  supportStatusPlanned: "Planned",
  supportStatusInProgress: "In progress",
  supportStatusResolved: "Resolved",
  supportStatusRejected: "Rejected",
  supportFormError: "Please add a title and description.",
  supportSubmitFailed: "Failed to submit request. Please try again.",
  supportResponseNote: "You can add more requests anytime.",
  delete: "Delete",
  confirmDelete: "Are you sure you want to delete this support request?",
  confirm: "Confirm",
  supportDeleteFailed: "Failed to delete request. Please try again.",

  // Landing Page
  heroTitle: "Turn Audience Silence into Real-time Insight.",
  heroSubtitle:
    "The AI-powered Q&A platform that moderates, groups, and summarizes audience questions instantly. No login required for participants.",
  features: "Features",
  howItWorks: "How it works",
  presenterLogin: "Presenter Login",
  goToDashboard: "Go to Dashboard",
  dashboardLabel: "Dashboard",
  buyMeCoffee: "Buy me a coffee",
  newPresentationMode: "New: Interactive Presentation Mode",
  superchargedByGemini: "Supercharged by Gemini 3 Pro",
  aiEngineDesc:
    "We don't just collect questions. We understand them. Our AI engine groups topics, filters noise, and prioritizes what matters.",
  semanticGrouping: "Semantic Grouping",
  semanticGroupingDesc:
    'Ten people asked about "Remote Work," but phrasing it differently? VoxPop sees one main topic. Keep your Q&A clean and focused.',
  slideSyncDesc:
    "Upload your slides. Questions are automatically tagged to the slide on screen.",
  smartSuggestion: "Smart Suggestions",
  smartSuggestionDesc:
    "Help your audience ask better questions. Our AI suggests improvements based on the Pyramid Principle—clarity, logic, and impact.",
  liveInsights: "Live Insights",
  liveInsightsDesc:
    "Get a real-time pulse of audience sentiment and engagement levels as you speak.",
  feedbackModeDesc:
    "Wrap up your session by asking for ratings and key takeaways. VoxPop generates a text summary for everyone to keep.",
  seeDemo: "See Demo",
  effortlessTitle: "Effortless for everyone",
  createSession: "Create a Session",
  createSessionDesc:
    "Host sets up a channel in seconds. No complex configuration needed.",
  audienceJoinsQR: "Audience Joins via QR",
  audienceJoinsQRDesc:
    "No app download. No login. Just point the camera and start asking.",
  aiModeratesGroups: "AI Moderates & Groups",
  aiModeratesGroupsDesc:
    "Questions appear on the host dashboard, organized by topic and importance.",
  readyToEngage: "Ready to engage?",
  readyToEngageDesc:
    "Join thousands of presenters who use VoxPop to make their sessions unforgettable.",
  getStartedFree: "Get Started for Free",
  noCreditCardDesc: "No credit card required. Free tier forever.",

  sessionPlaceholder: "e.g. Q4 All Hands",
  geminiAnalysis: "Gemini Analysis",
  problemHeading: "Why Live Q&A is Broken",
  frictionlessTitle: "Frictionless Participation",
  knowAudienceTitle: "Know Your Audience",
  high: "High",
  featGrammar: "Grammar Fix",
  featProfanity: "Profanity Filter",
  featTopic: "Topic Tagging",
  featGrouping: "Smart Grouping",
  mockPricing: "Pricing",
  mockAPI: "API",
  mockSecurity: "Security",
  footerText: "© 2024 VoxPop AI. Powered by Google Gemini.",
  joinInstruction: "Enter the 8-character code provided by the host.",
  tapToAsk: "Tap below to ask!",

  // Settings View Translations
  settings: "Settings",
  appearance: "Appearance",
  language: "Language",
  theme: "Theme",
  auroraEffect: "Aurora Effect",
  auroraEffectDesc: "Dynamic background animations",
  sessionDetails: "Session Details",
  participation: "Participation",
  participants: "Participants",
  saveChanges: "Save Changes",
  saving: "Saving...",
  confirmAccessControlChange: "Enabling access control may disconnect or require login for current participants. Are you sure you want to proceed?",
  copied: "Copied!",

  // ApiKeyBanner & Onboarding
  aiFeaturesDisabled: "AI Features Disabled",
  enableAiFeatures:
    "Please add your Gemini API Key in Settings to enable AI features.",
  aiWarningTitle: "AI Warning",
  aiTokenPreconditionMessage:
    "AI features are temporarily unavailable (412). If you're the presenter, check your Gemini API key in Settings, ensure it is active with billing enabled, then try again.",
  aiQuotaExceededMessage:
    "AI quota or rate limit reached. Please wait a bit, then retry or check your Gemini plan and billing.",
  welcome: "Welcome",
  setupPrompt:
    "Let's get VoxPop AI set up for you. We need an API key to power the AI magic.",
  activateAi: "Activate",
  activateAiDesc:
    "VoxPop AI uses Google Gemini to generate summaries, analyze questions, and give you presenting superpowers.",
  getStarted: "Get Started",
  enterGeminiKey: "Enter Gemini API Key",
  keyStoredLocally:
    "Your key is stored locally and encrypted on your device. We never see it.",
  needKeyPrompt: "Need a key? Get one for free at",
  saveContinue: "Save & Continue",
  viewPresenter: "Presenter",
  viewAudience: "Audience",
  loading: "Loading...",
  incorrectPin: "Incorrect PIN code",
  errorValidatingPin: "Error validating PIN",
  sessionId: "Session ID",
  sessionIdPlaceholder: "e.g. A1B2-C3D4…",
  copyJoinLink: "Copy Join Link",
  analyticsInsights: "Analytics & Insights",
  popularTopics: "Popular Topics",
  aiConsultant: "AI Consultant",
  aiConsultantDesc:
    "Analyze questions to find patterns and summarize the session.",
  runAnalysis: "Run Analysis",
  regenerateSummary: "Regenerate Summary",
  addApiKeyFirst: "Add API Key First",
  advancedInsightsComingSoon: "Advanced Insights Coming Soon",
  advancedInsightsDesc:
    "Deeper AI analysis of sentiment and engagement trends.",
  endSessionDesc:
    "Ending the session allows you to collect feedback. Participants won't be able to ask new questions.",

  // FeedbackView
  ratePrompt: "How would you rate this presentation?",
  keyTakeaway: "One Key Takeaway?",
  submitSeeCheatSheet: "Submit & See Cheat Sheet →",
  submitFeedbackBtn: "Submit Feedback",
  skipStep: "Skip this step",
  unlocked: "UNLOCKED",
  sessionLockedAlert: "Session is locked. No new questions allowed.",
  questionLimitReached: "You've reached your question limit for this session.",
  submitError: "Failed to submit question. Please check your connection.",
  sessionIsLocked: "Session is locked",
  generatingAiSummary: "Generative AI is summarizing the session…",
  savedToClipboard: "Saved to Clipboard!",
  copySummary: "Copy Summary",
  screenshotsEncouraged: "Screenshots encouraged! 📸",
  feedbackSubmitted: "Your feedback has been submitted successfully.",

  // ParticipantList
  onlineCount: "Online",
  anonymous: "Anonymous",
  noParticipants: "No one else here yet.",
  joinedAt: "Joined",

  // QuestionCard
  pinned: "Pinned",
  onHold: "On Hold",
  waitingApproval: "Waiting for approval…",
  rejected: "Rejected",
  questionBlocked: "Question blocked: inappropriate content detected.",
  editedFrom: "Edited from:",
  ownQuestionVoteError: "You cannot vote on your own question",
  upvoteAria: "Upvote question, current count",
  voteCount: "Vote Count",
  markPending: "Mark as pending",
  markAnsweredDone: "Mark as answered",
  markDone: "Done",
  markDoneShort: "Mark Done",
  removeFromFavorites: "Remove from favorites",
  addToFavorites: "Add to favorites",
  unpinQuestion: "Unpin question",
  pinQuestion: "Pin question",

  // PresenterDashboard & LandingPage
  slideNum: "Slide",
  supportsFiles: "Supports Images (JPG, PNG) and PDF",
  addBtn: "Add",
  slideProcessing: "Processing",
  deleteSlide: "Delete slide",
  deleteSlideConfirm: "Delete this slide? This cannot be undone.",
  liveIndicator: "LIVE",
  aiReady: "AI Ready",
  newCount: "new",
  unrelatedQuestions: "Unrelated to specific slides",
  generalQuestionsDesc:
    "Questions that the AI couldn't link to a specific slide.",
  archivedStatus: "Archived",
  all: "All",
  analyzingSlides: "Analyzing slides with AI...",
  analyzedSlideProgress: "Analyzed slide",
  processingFiles: "Processing files...",
  pdfProcessError: "Could not process PDF:",
  uploadingProgress: "Uploading",
  aiAnalysisPrefix: "AI Analysis:",
  noQuestionsSlide: "No questions asked on this slide yet.",
  fileTooLarge: "File size too large.",
  maxSize: "(Max {0}MB)",
  unsupportedFiles: "Some files are not supported. Allowed: {0}",
  filesSelected: "{0} files selected",
  idShort: "ID:",
  enterPinPlaceholder: "Enter 6-digit PIN…",
  signOut: "Sign Out",
  signInRequired: "Please sign in to submit a request.",
  newSession: "New Session",
  joinExisting: "Join Existing",
  lightTheme: "Light",
  darkTheme: "Dark",
  systemTheme: "System",
  statusLive: "Live",
  limitLabel: "Limit",
  pinCodeLabel: "PIN Code",
  changesSaved: "Changes saved successfully!",
  votesLabel: "Votes",
  pressEnter: "Press Enter",
  enterKey: "Enter",

  // User Dashboard
  myDashboard: "My Dashboard",
  editProfile: "Edit Profile",
  profile: "Profile",
  sessionHistory: "Session History",
  updateProfile: "Update Profile",
  displayName: "Display Name",
  photoUrl: "Photo URL",
  saveProfile: "Save Profile",
  profileUpdated: "Profile updated successfully",
  noSessions: "No sessions found",
  createFirstSession: "Create your first session to get started!",
  viewSession: "View Session",
  sessions: "Sessions",
  joined: "Joined",
  created: "Created",

  // New Dashboard Keys
  welcomeBack: "Welcome back",
  totalSessions: "Sessions",
  activeSessions: "Active",
  yourSessions: "Your Sessions",
  manageSessionsSubtitle: "Manage and monitor your audience feedback channels",
  readyToStart: "Ready to start?",
  creating: "Creating",
  logout: "Log Out",
  activeSessionDetected: "Active Session Detected",
  archivePrompt:
    "You have a live session. It must be archived to start a new one.",
  returnToLiveSessionPrompt: "You have a live session in progress.",
  archiveAndCreate: "Archive & Create",
  archiveAndCreateNew: "Archive & Create New",
  returnToSession: "Return to Live Session",
  or: "OR",
  errorArchiving: "Error archiving session",
  errorUploadingSlide: "Error uploading slide. Session created without it.",
  geminiApiKey: "Gemini API Key",
  geminiApiKeyPlaceholder: "Enter your Gemini API Key",
  geminiPrivacyNote: "Your key is stored locally in your browser and never sent to our servers.",
  aiStatusActive: "AI Active",
  aiStatusInactive: "AI Inactive",
  aiActiveBenefit: "Smart grouping & summaries ready.",
  aiInactiveAction: "Add key to unlock AI powers",
  getKeyLink: "Get free Gemini API Key",
  sessionNoAiPower: "Note: Your session won't have AI power for serving because API is not activated.",
  backToDashboard: "Back to Dashboard",
  manageYourSettings: "Manage your global preferences and AI configuration",
  appPreferences: "App Preferences",
  aiConfigurationMoved: "AI Configuration Moved",
  aiConfigurationMovedDesc: "Gemini AI settings are now global. You can manage your API key for all sessions in one place.",
  goToUserSettings: "Go to User Settings",
  manageAiKeysInSettings: "Manage your Gemini API keys in global settings",
  goToSettings: "Go to Settings",
  aiConfiguration: "AI Configuration",
  sessionEndedReadOnly: "Session Ended (Read Only)",
  maxSessionsReached: "You have reached the maximum number of sessions. Please archive or delete old ones to create a new session.",
  sessionActions: "Session Actions",

  // Tour
  tourViewSwitcherTitle: "View Switcher",
  tourViewSwitcherDesc: "Toggle between Presenter View (dashboard) and Audience View (what users see).",
  tourLiveFeedTitle: "Live Feed",
  tourLiveFeedDesc: "Monitor incoming questions from the audience in real-time. Favorite, pin, or mark them as answered.",
  tourSlideSyncTitle: "Slide Sync",
  tourSlideSyncDesc: "Upload your presentation slides to automatically group incoming questions by slide.",
  tourAiInsightsTitle: "AI Insights",
  tourAiInsightsDesc: "Use Gemini 3 Pro to generate summaries, analyze sentiment, and spot trending topics instantly.",
  tourFeedbackLoopTitle: "Feedback Loop",
  tourFeedbackLoopDesc: "When ending your session, switch to this tab to collect audience ratings and key takeaways before closing.",
  tourSettingsTitle: "Settings & API Key",
  tourSettingsDesc: "Configure your session options and enter your Gemini API Key here to enable AI features.",
  tourJoinCodeTitle: "Join Code",
  tourJoinCodeDesc: "Click here to show the QR code and session ID for your audience to join.",
  tourMobileSettingsTitle: "Settings & Actions",
  tourMobileSettingsDesc: "Access session settings from here. You can also find the QR Code, Export CSV, and End Session buttons in this menu.",

  // CSV Export
  author: "Author",
  text: "Text",
  topic: "Topic",
  upvotes: "Upvotes",
  status: "Status",
  timestamp: "Timestamp",
  toggleParticipantList: "Toggle active participant list",
  rateStarAria: "Rate {0} out of 5",
  copyToClipboardAria: "Copy summary to clipboard",
};

const es = {
  appTitle: "VoxPop AI",
  appDesc: "Participación de audiencia en tiempo real",
  startSession: "Iniciar Sesión de PyR",
  joinSession: "Unirse vía ID",
  orJoin: "o unirse a existente",
  setupSession: "Configurar Sesión",
  configureChannel: "Configura tu canal de PyR",
  sessionTitle: "Título de la Sesión",
  descOptional: "Descripción (Opcional)",
  maxQuestions: "Máx Preguntas/Usuario",
  accessControl: "Control de Acceso",
  protected: "Protegido",
  public: "Público",
  optional: "Opcional",
  requiresPin: "Requiere PIN",
  requireLogin: "Requerir inicio con Google",
  requireLoginDesc: "La audiencia debe iniciar sesión con Google antes de unirse.",
  freeToJoin: "Entrada libre",
  addDescriptionPrompt: "Añade una descripción para ayudar a la IA a entender el contexto...",
  uploadSlidePrompt: "Sube una presentación para guiar visualmente a tu audiencia...",
  uploadSlideBtn: "Subir presentación",
  optionalEncouragement: "Opcional, pero recomendado para mejores resultados de IA.",
  cancel: "Cancelar",
  close: "Cerrar",
  createChannel: "Crear Canal",
  joinTitle: "¡Bienvenido!",
  joining: "Te estás uniendo",
  yourName: "Tu Nombre",
  leaveBlank: "Dejar en blanco para usar",
  joinBtn: "Unirse a la Sesión",
  loginRequiredTitle: "Inicia sesión para unirte",
  loginRequiredDesc: "Esta sesión requiere inicio con Google antes de unirte.",
  continueWithGoogle: "Continuar con Google",
  signedInAs: "Conectado como",
  recent: "Reciente",
  popular: "Más Votados",
  mine: "Mis Preguntas",
  noQuestions: "No hay preguntas aún",
  typeQuestion: "Escribe una pregunta...",
  askingDisabled: "Las preguntas están deshabilitadas",
  postAs: "Publicar como",
  left: "restantes",
  liveFeed: "En Vivo",
  analytics: "Analítica",
  insights: "Insights IA",
  exportCSV: "Exportar CSV",
  endSession: "Terminar Sesión",
  sessionEnded: "Sesión Finalizada",
  joinCode: "Código de Unión",
  showQR: "Mostrar QR",
  trendingTopics: "Temas en Tendencia",
  engagement: "Participación",
  active: "Activo",
  passive: "Pasivo",
  aiAnalysisReady: "Análisis IA Listo",
  generateInsights: "Generar Insights en Vivo",
  addApiKey: "Añadir API Key para Habilitar IA",
  removeApiKeyTitle: "¿Eliminar la clave API?",
  removeApiKeyConfirm: "Las funciones de IA dejarán de funcionar hasta que guardes una nueva clave.",
  removeApiKeyAction: "Eliminar clave",
  refreshAnalysis: "Actualizar Análisis",
  online: "En línea",
  activeParticipants: "Participantes Activos",
  markAnswered: "Marcar Respondida",
  answered: "Respondida",
  hide: "Ocultar",
  unhide: "Mostrar",
  favorite: "Favorito",
  pin: "Fijar al Inicio",
  analyzing: "Analizando...",
  autoGroup: "Agrupar Temas Auto",
  checkGrammar: "Sugerencia",
  reanalyze: "Reanalizar",
  checking: "Comprobando...",
  aiSuggestion: "Sugerencia IA",
  applyChange: "Aplicar Cambio",
  dismiss: "Descartar",
  questions: "Preguntas",
  endSessionConfirmTitle: "¿Terminar Sesión?",
  endSessionConfirmBody:
    "Esto cerrará permanentemente la sesión. Los participantes serán desconectados y no podrán acceder. Volverás a la pantalla de inicio.",
  confirmEnd: "Sí, Terminar Sesión",
  sessionUnavailable: "Sesión No Disponible",
  createError: "Error al crear la sesión. Inténtalo de nuevo.",
  error: "Error",
  sessionEndedMessage:
    "Esta sesión de PyR ha terminado y ya no está disponible.",
  backToHome: "Volver al Inicio",
  aiPriorityEx:
    "Puntaje calculado en base a gramática, claridad y relevancia del tema.",
  presentationMode: "Modo Presentación",
  startPresentation: "Iniciar Presentación",
  presenting: "Presentando",
  noQuestionsFilter: "No hay preguntas para presentar con este filtro",
  exitPresentation: "Salir de Presentación",
  next: "Siguiente",
  prev: "Anterior",
  shortcuts: "Atajos",
  markAnsweredShort: "Marcar Respondida",
  keyboardHint: "Usa ← → para navegar, Enter para responder, Esc para salir",

  // Slide Features
  slides: "Diapositivas",
  uploadSlides: "Subir Diapositivas",
  uploadSlidesDesc:
    "Sube tu presentación (imágenes) para agrupar preguntas por diapositiva.",
  uploadBtn: "Seleccionar Imágenes",
  processingSlides: "Procesando diapositivas...",
  generalQuestions: "General / Meta",
  currentSlide: "Diapositiva Actual",
  setAsCurrent: "Fijar como Actual",
  questionsForSlide: "Preguntas para Diapositiva",

  // Feedback Mode
  softCloseTitle: "¿Concluir Sesión?",
  softCloseBody:
    "Puedes entrar en 'Modo Feedback' para detener nuevas preguntas y pedir calificación. O terminar inmediatamente.",
  startFeedback: "Iniciar Modo Feedback",
  skipFeedback: "Omitir Feedback y Terminar",
  endImmediately: "Terminar Inmediatamente",
  feedbackMode: "Modo Feedback",
  feedbackLive: "El Feedback está en Vivo",
  feedbackLocked: "Feedback Bloqueado",
  feedbackLockedDesc:
    "Inicia el modo de feedback para permitir que la audiencia califique la sesión y desbloquee su Cheat Sheet.",
  startFeedbackMode: "Iniciar Modo de Feedback",
  finalResults: "Resultados finales",
  responded: "Respondido",
  participantsLabel: "participantes",
  liveComments: "Comentarios en Vivo",
  waitingForComments: "Esperando comentarios...",
  noComment: "Sin comentarios proporcionados",
  waitingForFeedback: "Esperando audiencia feedback...",
  analyzeSentiment: "Analizar sentimiento",
  reanalyzeSentiment: "Reanalizar sentimiento",
  averageRating: "Calificación Promedio",
  netScore: "Puntaje de Sesión",
  archiveSession: "Archivar y Cerrar",
  rateSession: "Calificar esta Sesión",
  feedbackPlaceholder: "¿Cuál fue tu conclusión clave? (Opcional)",
  submitFeedback: "Enviar Feedback",
  thankYou: "¡Gracias!",
  aiTakeawayTitle: "Tu Resumen IA de la Sesión",
  aiTakeawayDesc: "VoxPop analizó la sesión y generó este resumen para ti.",
  generatingTakeaway: "Generando tu resumen de sesión...",
  generateTakeawayDesc: "Genera un resumen conciso de las diapositivas y PyR para tu audiencia.",
  generateBtn: "Generar",
  updating: "Actualizando...",
  copy: "Copiar",
  feedbackReport: "Reporte de Feedback",
  exitSession: "Salir de la Sesión",
  remove: "Eliminar",

  // Support Requests
  supportCenter: "Soporte",
  supportCenterDesc:
    "Envía solicitudes de funciones o informes de errores. Adjunta archivos y sigue el estado aquí.",
  requestType: "Tipo de solicitud",
  requestTypeFeature: "Solicitud de función",
  requestTypeBug: "Informe de error",
  requestTitle: "Título",
  requestTitlePlaceholder: "Resumen corto",
  requestDescription: "Detalles",
  requestDescriptionPlaceholder: "Pasos, comportamiento esperado y contexto.",
  attachments: "Adjuntos",
  submitRequest: "Enviar solicitud",
  submitting: "Enviando...",
  requestStatus: "Tus solicitudes",
  noSupportRequests: "No hay solicitudes enviadas aún.",
  supportStatusSubmitted: "Enviado",
  supportStatusInReview: "En revisión",
  supportStatusPlanned: "Planificado",
  supportStatusInProgress: "En progreso",
  supportStatusResolved: "Resuelto",
  supportStatusRejected: "Rechazado",
  supportFormError: "Por favor añade un título y una descripción.",
  supportSubmitFailed: "Error al enviar la solicitud. Por favor intenta de nuevo.",
  supportResponseNote: "Puedes añadir más solicitudes en cualquier momento.",
  delete: "Eliminar",
  confirmDelete: "¿Estás seguro de que deseas eliminar esta solicitud de soporte?",
  confirm: "Confirmar",
  supportDeleteFailed: "Error al eliminar la solicitud. Por favor intente de nuevo.",

  // Landing Page
  heroTitle:
    "Convierte el silencio de la audiencia en información en tiempo real.",
  heroSubtitle:
    "La plataforma de PyR con IA que modera, agrupa y resume las preguntas de la audiencia al instante. Sin necesidad de inicio de sesión.",
  features: "Características",
  howItWorks: "Cómo funciona",
  presenterLogin: "Inicio de sesión del presentador",
  goToDashboard: "Ir al Panel",
  dashboardLabel: "Panel de Control",
  newPresentationMode: "Nuevo: Modo de Presentación Interactivo",
  superchargedByGemini: "Potenciado por Gemini 3 Pro",
  aiEngineDesc:
    "No solo recopilamos preguntas. Las entendemos. Nuestro motor de IA agrupa temas, filtra el ruido y prioriza lo importante.",
  semanticGrouping: "Agrupación Semántica",
  semanticGroupingDesc:
    "Si diez personas preguntan sobre el trabajo remoto de formas diferentes, VoxPop identifica el tema principal. Mantén tu PyR limpio y enfocado.",
  slideSyncDesc:
    "Sube tus diapositivas. Las preguntas se etiquetan automáticamente según la diapositiva en pantalla.",
  smartSuggestion: "Sugerencias Inteligentes",
  smartSuggestionDesc:
    "Ayuda a tu audiencia a hacer mejores preguntas. Nuestra IA sugiere mejoras basadas en el Principio de la Pirámide: claridad, lógica e impacto.",
  liveInsights: "Insights en Vivo",
  liveInsightsDesc:
    "Obtén el pulso de la audiencia y los niveles de compromiso en tiempo real mientras hablas.",
  feedbackModeDesc:
    "Concluye tu sesión pidiendo calificaciones y conclusiones clave. VoxPop genera un resumen para todos.",
  seeDemo: "Ver Demo",
  effortlessTitle: "Fácil para todos",
  createSession: "Crear una Sesión",
  createSessionDesc:
    "El anfitrión configura un canal en segundos. Sin configuraciones complejas.",
  audienceJoinsQR: "Unirse vía QR",
  audienceJoinsQRDesc:
    "Sin descargas de apps. Sin login. Solo apunta la cámara y comienza a preguntar.",
  aiModeratesGroups: "IA Modera y Agrupa",
  aiModeratesGroupsDesc:
    "Las preguntas aparecen en el panel del anfitrión, organizadas por tema e importancia.",
  readyToEngage: "¿Listo para participar?",
  readyToEngageDesc:
    "Únete a miles de presentadores que usan VoxPop para hacer sus sesiones inolvidables.",
  getStartedFree: "Comenzar Gratis",
  noCreditCardDesc: "Sin tarjeta de crédito. Nivel gratuito para siempre.",
  buyMeCoffee: "Cómprame un café",

  sessionPlaceholder: "ej. Q4 Reunión General",
  geminiAnalysis: "Análisis Gemini",
  problemHeading: "¿Por qué el PyR en vivo está roto?",
  frictionlessTitle: "Participación sin Fricción",
  knowAudienceTitle: "Conoce a tu Audiencia",
  high: "Alto",
  featGrammar: "Corrección Gramatical",
  featProfanity: "Filtro de Profanidad",
  featTopic: "Etiquetado de Temas",
  featGrouping: "Agrupación Inteligente",
  mockPricing: "Precios",
  mockAPI: "API",
  mockSecurity: "Seguridad",
  footerText: "© 2024 VoxPop AI. Impulsado por Gemini 3 Pro.",
  joinInstruction:
    "Ingresa el código de 8 caracteres provisto por el anfitrión.",
  tapToAsk: "¡Toca abajo para preguntar!",

  // Settings
  settings: "Configuración",
  appearance: "Apariencia",
  language: "Idioma",
  theme: "Tema",
  sessionDetails: "Detalles de Sesión",
  participation: "Participación",
  participants: "Participantes",
  saveChanges: "Guardar Cambios",
  saving: "Guardando...",
  confirmAccessControlChange: "Habilitar el control de acceso puede desconectar a los participantes actuales. ¿Estás seguro de continuar?",
  copied: "¡Copiado!",

  // ApiKeyBanner & Onboarding
  aiFeaturesDisabled: "Funciones de IA Desactivadas",
  enableAiFeatures:
    "Por favor agrega tu clave API de Gemini en Configuración para activar la IA.",
  aiWarningTitle: "Advertencia de IA",
  aiTokenPreconditionMessage:
    "Las funciones de IA no están disponibles temporalmente (412). Si eres el presentador, revisa tu clave API de Gemini en Configuración, confirma que esté activa con facturación habilitada y vuelve a intentarlo.",
  aiQuotaExceededMessage:
    "Se alcanzó el límite de cuota o velocidad de IA. Espera un momento y vuelve a intentarlo, o revisa tu plan y facturación de Gemini.",
  welcome: "Bienvenido",
  setupPrompt:
    "Configuremos VoxPop AI para ti. Necesitamos una clave API para la magia de la IA.",
  activateAi: "Activar",
  activateAiDesc:
    "VoxPop AI usa Google Gemini para generar resúmenes, analizar preguntas y darte superpoderes de presentación.",
  getStarted: "Comenzar",
  enterGeminiKey: "Ingresar Clave API Gemini",
  keyStoredLocally:
    "Tu clave se guarda localmente y encriptada. Nunca la vemos.",
  needKeyPrompt: "¿Necesitas una clave? Consíguela gratis en",
  saveContinue: "Guardar y Continuar",
  viewPresenter: "Presentador",
  viewAudience: "Audiencia",
  loading: "Cargando...",
  incorrectPin: "PIN incorrecto",
  errorValidatingPin: "Error al validar el PIN",
  sessionId: "ID de Sesión",
  sessionIdPlaceholder: "ej. A1B2-C3D4…",
  copyJoinLink: "Copiar enlace para unirse",
  analyticsInsights: "Análisis e Información",
  popularTopics: "Temas Populares",
  aiConsultant: "Consultor de IA",
  aiConsultantDesc:
    "Analizar preguntas para encontrar patrones y resumir la sesión.",
  runAnalysis: "Ejecutar Análisis",
  regenerateSummary: "Regenerar resumen",
  addApiKeyFirst: "Añadir Clave API Primero",
  advancedInsightsComingSoon: "Perspectivas Avanzadas Próximamente",
  advancedInsightsDesc:
    "Análisis de IA más profundo sobre sentimientos y tendencias.",
  endSessionDesc:
    "Terminar la sesión permite recopilar comentarios. Los participantes no podrán hacer nuevas preguntas.",
  tourMobileSettingsTitle: "Configuración y Acciones",
  tourMobileSettingsDesc: "Accede a la configuración de la sesión desde aquí. También puedes encontrar los botones de Código QR, Exportar CSV y Finalizar sesión en este menú.",
  sessionActions: "Acciones de la Sesión",

  // FeedbackView
  ratePrompt: "¿Cómo calificarías esta presentación?",
  keyTakeaway: "¿Una conclusión clave?",
  submitSeeCheatSheet: "Enviar y Ver Hoja de Trucos →",
  submitFeedbackBtn: "Enviar Feedback",
  skipStep: "Saltar este paso",
  unlocked: "DESBLOQUEADO",
  sessionLockedAlert: "La sesión está bloqueada. No se permiten más preguntas.",
  questionLimitReached:
    "Has alcanzado el límite de preguntas para esta sesión.",
  submitError: "Error al enviar la pregunta. Por favor, comprueba tu conexión.",
  sessionIsLocked: "La sesión está bloqueada",
  generatingAiSummary: "La IA generativa está resumiendo la sesión…",
  savedToClipboard: "¡Guardado en Portapapeles!",
  copySummary: "Copiar Resumen",
  screenshotsEncouraged: "¡Se recomiendan capturas! 📸",
  feedbackSubmitted: "Tu feedback se ha enviado con éxito.",

  // ParticipantList
  onlineCount: "En línea",
  anonymous: "Anónimo",
  noParticipants: "Nadie más aquí todavía.",
  joinedAt: "Se unió",

  // QuestionCard
  pinned: "Fijado",
  onHold: "En Espera",
  waitingApproval: "Esperando aprobación…",
  rejected: "Rechazado",
  questionBlocked: "Pregunta bloqueada: contenido inapropiado.",
  editedFrom: "Editado de:",
  ownQuestionVoteError: "No puedes votar tu propia pregunta",
  upvoteAria: "Votar pregunta, conteo actual",
  voteCount: "Conteo de Votos",
  markPending: "Marcar como pendiente",
  markAnsweredDone: "Marcar como respondida",
  markDone: "Hecho",
  markDoneShort: "Marcar Hecho",
  removeFromFavorites: "Quitar de favoritos",
  addToFavorites: "Añadir a favoritos",
  unpinQuestion: "Desfijar pregunta",
  pinQuestion: "Fijar pregunta",

  // PresenterDashboard & LandingPage
  slideNum: "Diapositiva",
  supportsFiles: "Soporta imágenes (JPG, PNG) y PDF",
  addBtn: "Añadir",
  slideProcessing: "Procesando",
  deleteSlide: "Eliminar diapositiva",
  deleteSlideConfirm:
    "¿Eliminar esta diapositiva? Esta acción no se puede deshacer.",
  liveIndicator: "EN VIVO",
  aiReady: "Lista IA",
  newCount: "nuevos",
  unrelatedQuestions: "No relacionado con diapositivas específicas",
  generalQuestionsDesc:
    "Preguntas que la IA no pudo vincular a una diapositiva específica.",
  archivedStatus: "Archivado",
  all: "Todo",
  analyzingSlides: "Analizando diapositivas con IA...",
  analyzedSlideProgress: "Diapositiva analizada",
  processingFiles: "Procesando archivos...",
  pdfProcessError: "No se pudo procesar el PDF:",
  uploadingProgress: "Subiendo",
  aiAnalysisPrefix: "Análisis IA:",
  noQuestionsSlide: "Aún no hay preguntas sobre esta diapositiva.",
  fileTooLarge: "Archivo demasiado grande.",
  maxSize: "(Máx {0}MB)",
  unsupportedFiles: "Algunos archivos no son compatibles. Permitido: {0}",
  filesSelected: "{0} archivos seleccionados",
  idShort: "ID:",
  enterPinPlaceholder: "Ingresa PIN de 6 dígitos…",
  signOut: "Cerrar Sesión",
  signInRequired: "Por favor inicia sesión para enviar una solicitud.",
  newSession: "Nueva Sesión",
  joinExisting: "Unirse a Existente",
  lightTheme: "Claro",
  darkTheme: "Modo Oscuro",
  systemTheme: "Sistema",
  auroraEffect: "Efecto Aurora",
  auroraEffectDesc: "Animaciones de fondo dinámicas",
  statusLive: "En Vivo",
  limitLabel: "Límite",
  pinCodeLabel: "Código PIN",
  changesSaved: "¡Cambios guardados con éxito!",
  votesLabel: "Votos",
  pressEnter: "Presiona Enter",
  enterKey: "Enter",

  // User Dashboard
  myDashboard: "Mi Tablero",
  editProfile: "Editar Perfil",
  profile: "Perfil",
  sessionHistory: "Historial de Sesiones",
  updateProfile: "Actualizar Perfil",
  displayName: "Nombre a mostrar",
  photoUrl: "URL de la foto",
  saveProfile: "Guardar Perfil",
  profileUpdated: "Perfil actualizado con éxito",
  noSessions: "No se encontraron sesiones",
  createFirstSession: "¡Crea tu primera sesión para comenzar!",
  viewSession: "Ver Sesión",
  sessions: "Sesiones",
  joined: "Unido",
  created: "Creado",

  // New Dashboard Keys
  welcomeBack: "Bienvenido de nuevo",
  totalSessions: "Sesiones",
  activeSessions: "Sesiones Activas",
  yourSessions: "Tus Sesiones",
  manageSessionsSubtitle: "Gestiona y monitorea tus canales de feedback",
  readyToStart: "¿Listo para empezar?",
  creating: "Creando",
  logout: "Cerrar Sesión",
  activeSessionDetected: "Sesión Activa Detectada",
  archivePrompt:
    "Tienes una sesión en vivo. Debes archivarla para empezar una nueva.",
  returnToLiveSessionPrompt: "Tienes una sesión en curso.",
  archiveAndCreateNew: "Archivar y Crear Nueva",
  returnToSession: "Volver a la Sesión en Vivo",
  or: "O",
  maxSessionsReached:
    "Has alcanzado el número máximo de sesiones. Por favor archiva o elimina las antiguas para crear una nueva.",
  archiveAndCreate: "Archivar y Crear",
  errorArchiving: "Error al archivar sesión",
  errorUploadingSlide: "Error al subir diapositiva. Sesión creada sin ella.",
  geminiApiKey: "Clave API de Gemini",
  geminiApiKeyPlaceholder: "Introduce tu clave API de Gemini",
  geminiPrivacyNote:
    "Tu clave se almacena localmente en tu navegador y nunca se envía a nuestros servidores.",
  aiStatusActive: "Gemini AI Activo",
  aiStatusInactive: "IA Inactiva",
  aiActiveBenefit:
    "Impulsa la participación con agrupación inteligente y resúmenes.",
  aiInactiveAction: "Añade clave para desbloquear IA",
  getKeyLink: "Obtén clave Gemini gratis",
  sessionNoAiPower:
    "Nota: Tu sesión no tendrá poder de IA porque la API no está activada.",
  backToDashboard: "Volver al Panel",
  manageYourSettings:
    "Gestiona tus preferencias globales y la configuración de IA",
  appPreferences: "Preferencias de la aplicación",
  aiConfigurationMoved: "Configuración de IA movida",
  aiConfigurationMovedDesc:
    "Los ajustes de Gemini AI ahora son globales. Puedes gestionar tu clave API para todas las sesiones en un solo lugar.",
  goToUserSettings: "Ir a Ajustes de Usuario",
  manageAiKeysInSettings:
    "Gestiona tus claves API de Gemini en los ajustes globales",
  goToSettings: "Ir a Configuración",
  aiConfiguration: "Configuración de IA",
  sessionEndedReadOnly: "Sesión Finalizada (Solo Lectura)",

  // Tour
  tourViewSwitcherTitle: "Selector de Vista",
  tourViewSwitcherDesc: "Cambia entre la Vista de Presentador (panel de control) y la Vista de Audiencia (lo que ven los usuarios).",
  tourLiveFeedTitle: "Feed en Vivo",
  tourLiveFeedDesc: "Monitorea las preguntas entrantes de la audiencia en tiempo real. Márcalas como favoritas, fíjalas o márcalas como respondidas.",
  tourSlideSyncTitle: "Sincronización de Diapositivas",
  tourSlideSyncDesc: "Sube tus diapositivas para agrupar automáticamente las preguntas entrantes por diapositiva.",
  tourAiInsightsTitle: "Información de IA",
  tourAiInsightsDesc: "Usa Gemini 3 Pro para generar resúmenes, analizar el sentimiento e identificar temas de tendencia al instante.",
  tourFeedbackLoopTitle: "Bucle de Retroalimentación",
  tourFeedbackLoopDesc: "Al terminar tu sesión, cambia a esta pestaña para recopilar calificaciones de la audiencia y conclusiones clave antes de cerrar.",
  tourSettingsTitle: "Configuración y Clave API",
  tourSettingsDesc: "Configura las opciones de tu sesión e ingresa tu clave API de Gemini aquí para habilitar las funciones de IA.",
  tourJoinCodeTitle: "Código de Unión",
  tourJoinCodeDesc: "Haz clic aquí para mostrar el código QR y el ID de sesión para que tu audiencia se una.",

  // CSV Export
  author: "Autor",
  text: "Texto",
  topic: "Tema",
  upvotes: "Votos",
  status: "Estado",
  timestamp: "Marca de tiempo",
  toggleParticipantList: "Alternar lista de participantes activos",
  rateStarAria: "Calificar con {0} de 5",
  copyToClipboardAria: "Copiar resumen al portapapeles",
};

const fr = {
  appTitle: "VoxPop AI",
  appDesc: "Engagement d'audience en temps réel",
  startSession: "Nouvelle Session Q&R",
  joinSession: "Rejoindre via ID",
  orJoin: "ou rejoindre une existante",
  setupSession: "Configurer la Session",
  configureChannel: "Configurez votre canal Q&R",
  sessionTitle: "Titre de la Session",
  descOptional: "Description (Optionnel)",
  maxQuestions: "Max Questions/Utilisateur",
  accessControl: "Contrôle d'Accès",
  protected: "Protégé",
  public: "Public",
  optional: "Facultatif",
  requiresPin: "Code PIN requis",
  requireLogin: "Exiger la connexion Google",
  requireLoginDesc: "Le public doit se connecter avec Google avant de rejoindre.",
  freeToJoin: "Accès libre",
  addDescriptionPrompt: "Ajoutez une description pour aider l'IA à comprendre le contexte...",
  uploadSlidePrompt: "Téléchargez une présentation pour guider visuellement votre public...",
  uploadSlideBtn: "Télécharger la présentation",
  optionalEncouragement: "Facultatif, mais recommandé pour de meilleurs résultats d'IA.",
  cancel: "Annuler",
  close: "Fermer",
  createChannel: "Créer Canal",
  joinTitle: "Bienvenue !",
  joining: "Vous rejoignez",
  yourName: "Votre Nom",
  leaveBlank: "Laisser vide pour utiliser",
  joinBtn: "Rejoindre la Session",
  loginRequiredTitle: "Connectez-vous pour rejoindre",
  loginRequiredDesc: "Cette session nécessite une connexion Google avant de rejoindre.",
  continueWithGoogle: "Continuer avec Google",
  signedInAs: "Connecté en tant que",
  recent: "Récent",
  popular: "Populaire",
  mine: "Mes Qs",
  noQuestions: "Aucune question pour l'instant",
  typeQuestion: "Posez une question...",
  askingDisabled: "Les questions sont désactivées",
  postAs: "Publier en tant que",
  left: "restants",
  liveFeed: "Flux en Direct",
  analytics: "Analytique",
  insights: "Insights IA",
  exportCSV: "Exporter CSV",
  endSession: "Fin de Session",
  sessionEnded: "Session Terminée",
  joinCode: "Code de Participation",
  showQR: "Afficher QR",
  trendingTopics: "Sujets Tendances",
  engagement: "Engagement",
  active: "Actif",
  passive: "Passif",
  aiAnalysisReady: "Analyse IA Prête",
  generateInsights: "Générer Insights",
  addApiKey: "Ajouter Clé API pour IA",
  removeApiKeyTitle: "Supprimer la clé API ?",
  removeApiKeyConfirm: "Les fonctions d'IA cesseront de fonctionner jusqu'à l'enregistrement d'une nouvelle clé.",
  removeApiKeyAction: "Supprimer la clé",
  refreshAnalysis: "Actualiser l'Analyse",
  online: "En ligne",
  activeParticipants: "Participants Actifs",
  markAnswered: "Marquer Répondu",
  answered: "Répondu",
  hide: "Masquer",
  unhide: "Afficher",
  favorite: "Favori",
  pin: "Épingler",
  analyzing: "Analyse...",
  autoGroup: "Grouper Sujets",
  checkGrammar: "Suggestion",
  reanalyze: "Réanalyser",
  checking: "Vérification...",
  aiSuggestion: "Suggestion IA",
  applyChange: "Appliquer",
  dismiss: "Ignorer",
  questions: "Questions",
  endSessionConfirmTitle: "Terminer la Session ?",
  endSessionConfirmBody:
    "Cela fermera définitivement la session. Les participants seront déconnectés.",
  confirmEnd: "Oui, Terminer",
  sessionUnavailable: "Session Indisponible",
  createError: "Échec de création. Réessayez.",
  error: "Erreur",
  sessionEndedMessage: "Cette session Q&R est terminée.",
  backToHome: "Retour Accueil",
  aiPriorityEx: "Score basé sur la grammaire, la clarté et la pertinence.",
  presentationMode: "Mode Présentation",
  startPresentation: "Démarrer Présentation",
  presenting: "Présentation",
  noQuestionsFilter: "Aucune question à présenter",
  exitPresentation: "Quitter Présentation",
  next: "Suivant",
  prev: "Précédent",
  shortcuts: "Raccourcis",
  markAnsweredShort: "Marquer Répondu",
  keyboardHint: "Utilisez ← → pour naviguer, Entrée pour répondre",

  slides: "Diapositives",
  uploadSlides: "Charger Diapositives",
  uploadSlidesDesc:
    "Chargez votre présentation pour grouper les questions par diapositive.",
  uploadBtn: "Choisir Images",
  processingSlides: "Traitement...",
  generalQuestions: "Général / Meta",
  currentSlide: "Diapositive Actuelle",
  setAsCurrent: "Définir comme Actuelle",
  questionsForSlide: "Questions pour Diapositive",

  softCloseTitle: "Conclure la Session ?",
  softCloseBody:
    "Passez en 'Mode Feedback' pour demander des avis, ou terminez immédiatement.",
  startFeedback: "Mode Feedback",
  skipFeedback: "Passer Feedback & Fin",
  endImmediately: "Terminer Immédiatement",
  feedbackMode: "Mode Feedback",
  feedbackLive: "Le Feedback est en cours",
  feedbackLocked: "Feedback Verrouillé",
  feedbackLockedDesc:
    "Lancez le mode feedback pour permettre à l'audience d'évaluer la session et de débloquer leur Cheat Sheet.",
  startFeedbackMode: "Lancer le mode Feedback",
  finalResults: "Résultats finaux",
  responded: "Répondu",
  participantsLabel: "participants",
  liveComments: "Commentaires en Direct",
  waitingForComments: "En attente de commentaires...",
  noComment: "Aucun commentaire fourni",
  waitingForFeedback: "En attente des avis...",
  analyzeSentiment: "Analyser le sentiment",
  reanalyzeSentiment: "Réanalyser le sentiment",
  averageRating: "Note Moyenne",
  netScore: "Score de Session",
  archiveSession: "Archiver & Fermer",
  rateSession: "Noter la Session",
  feedbackPlaceholder: "Ce que vous avez retenu ? (Optionnel)",
  submitFeedback: "Envoyer",
  thankYou: "Merci !",
  aiTakeawayTitle: "Votre Résumé IA",
  aiTakeawayDesc: "VoxPop a analysé la session et généré ce résumé.",
  generatingTakeaway: "Génération du résumé...",
  generateTakeawayDesc: "Générez un résumé concis des diapositives et des Q&R pour votre public.",
  generateBtn: "Générer",
  updating: "Mise à jour...",
  copy: "Copier",
  feedbackReport: "Rapport Feedback",
  exitSession: "Quitter Session",
  remove: "Supprimer",

  // Support Requests
  supportCenter: "Centre de Support",
  supportCenterDesc:
    "Envoyez des demandes de fonctionnalités ou des rapports de bogues. Joignez des fichiers et suivez le statut ici.",
  requestType: "Type de demande",
  requestTypeFeature: "Demande de fonctionnalité",
  requestTypeBug: "Rapport de bogue",
  requestTitle: "Titre",
  requestTitlePlaceholder: "Résumé court",
  requestDescription: "Détails",
  requestDescriptionPlaceholder: "Étapes, comportement attendu et contexte.",
  attachments: "Pièces jointes",
  submitRequest: "Envoyer la demande",
  submitting: "Envoi en cours...",
  requestStatus: "Vos demandes",
  noSupportRequests: "Aucune demande soumise pour l'instant.",
  supportStatusSubmitted: "Soumis",
  supportStatusInReview: "En révision",
  supportStatusPlanned: "Planifié",
  supportStatusInProgress: "En cours",
  supportStatusResolved: "Résolu",
  supportStatusRejected: "Rejeté",
  supportFormError: "Veuillez ajouter un titre et une description.",
  supportSubmitFailed: "Échec de l'envoi de la demande. Veuillez réessayer.",
  supportResponseNote: "Vous pouvez ajouter d'autres demandes à tout moment.",

  tourMobileSettingsTitle: "Paramètres et Actions",
  tourMobileSettingsDesc: "Accédez aux paramètres de session d'ici. Vous y trouverez également les boutons Code QR, Exporter CSV et Fin de Session.",
  sessionActions: "Actions de Session",

  // Landing Page
  heroTitle:
    "Transformez le silence de l'auditoire en informations en temps réel.",
  heroSubtitle:
    "La plateforme de Q&R alimentée par l'IA qui modère, groupe et résume instantanément les questions du public. Pas d'inscription requise.",
  features: "Fonctionnalités",
  howItWorks: "Comment ça marche",
  presenterLogin: "Connexion Présentateur",
  goToDashboard: "Aller au Tableau de Bord",
  dashboardLabel: "Tableau de Bord",
  newPresentationMode: "Nouveau : Mode Présentation Interactif",
  superchargedByGemini: "Propulsé par Gemini 3 Pro",
  aiEngineDesc:
    "Nous ne nous contentons pas de collecter les questions. Nous les comprenons. Notre moteur d'IA regroupe les sujets, filtre les bruits et priorise ce qui compte.",
  semanticGrouping: "Regroupement Sémantique",
  semanticGroupingDesc:
    "Si dix personnes posent des questions sur le télétravail différemment, VoxPop identifie le thème principal. Gardez votre Q&R propre et concentré.",
  slideSyncDesc:
    "Chargez vos diapositives. Les questions sont automatiquement taguées selon la diapositive affichée.",
  liveInsights: "Insights en Direct",
  liveInsightsDesc:
    "Obtenez le pouls de l'auditoire et le niveau d'engagement en temps réel pendant que vous parlez.",
  feedbackModeDesc:
    "Concluez votre session en demandant des notes et des points clés. VoxPop génère un résumé pour tous.",
  seeDemo: "Voir la Démo",
  effortlessTitle: "Facile pour tout le monde",
  createSession: "Créer une Session",
  createSessionDesc:
    "L'hôte configure un canal en quelques secondes. Aucune configuration complexe requise.",
  audienceJoinsQR: "Rejoindre via QR",
  audienceJoinsQRDesc:
    "Pas d'application à télécharger. Pas de connexion. Enregistrez juste par caméra et posez vos questions.",
  aiModeratesGroups: "L'IA Modère et Groupe",
  aiModeratesGroupsDesc:
    "Les questions apparaissent sur le tableau de bord de l'hôte, organisées par sujet et importance.",
  readyToEngage: "Prêt à s'engager ?",
  readyToEngageDesc:
    "Rejoignez des milliers de présentateurs qui utilisent VoxPop pour rendre leurs sessions inoubliables.",
  getStartedFree: "Commencer Gratuitement",
  noCreditCardDesc: "Pas de carte de crédit requise. Offre gratuite à vie.",
  buyMeCoffee: "Offrez-moi un café",

  sessionPlaceholder: "ex. Q4 Réunion",
  geminiAnalysis: "Analyse Gemini",
  problemHeading: "Pourquoi le Q&R est cassé",
  frictionlessTitle: "Participation Fluide",
  knowAudienceTitle: "Connaître votre Audience",
  high: "Élevé",
  featGrammar: "Grammaire",
  featProfanity: "Filtre Profanité",
  featTopic: "Tags Sujets",
  featGrouping: "Groupement",
  mockPricing: "Prix",
  mockAPI: "API",
  mockSecurity: "Sécurité",
  footerText: "© 2024 VoxPop AI. Propulsé par Gemini 3 Pro.",
  joinInstruction: "Entrez le code à 8 caractères.",
  tapToAsk: "Tapez pour demander !",

  settings: "Paramètres",
  appearance: "Apparence",
  language: "Langue",
  theme: "Thème",
  sessionDetails: "Détails Session",
  participation: "Participation",
  participants: "Participants",
  saveChanges: "Enregistrer",
  saving: "Enregistrement...",

  aiFeaturesDisabled: "Fonctionnalités IA Désactivées",
  enableAiFeatures:
    "Ajoutez votre clé API Gemini dans les Paramètres pour activer l'IA.",
  aiWarningTitle: "Alerte IA",
  aiTokenPreconditionMessage:
    "Les fonctionnalités IA sont temporairement indisponibles (412). Si vous êtes le présentateur, vérifiez votre clé API Gemini dans Paramètres, assurez-vous qu'elle est active avec la facturation activée, puis réessayez.",
  aiQuotaExceededMessage:
    "Quota ou limite de débit IA atteints. Veuillez patienter puis réessayer, ou vérifier votre forfait et la facturation Gemini.",
  welcome: "Bienvenue",
  setupPrompt:
    "Configurons VoxPop AI. Une clé API est requise pour la magie IA.",
  activateAi: "Activer",
  activateAiDesc: "VoxPop utilise Gemini pour les résumés et l'analyse.",
  getStarted: "Commencer",
  enterGeminiKey: "Entrer Clé API Gemini",
  keyStoredLocally: "Votre clé est stockée localement et chiffrée.",
  needKeyPrompt: "Besoin d'une clé ? Obtenez-la gratuitement sur",
  saveContinue: "Enregistrer & Continuer",
  viewPresenter: "Présentateur",
  viewAudience: "Audience",
  loading: "Chargement...",
  incorrectPin: "Code PIN incorrect",
  errorValidatingPin: "Erreur lors de la validation du PIN",
  sessionId: "ID de Session",
  sessionIdPlaceholder: "ex. A1B2-C3D4…",
  copyJoinLink: "Copier le lien d'invitation",
  analyticsInsights: "Analyses et Insights",
  popularTopics: "Sujets Populaires",
  aiConsultant: "Consultant IA",
  aiConsultantDesc:
    "Analyser les questions pour trouver des modèles et résumer la session.",
  runAnalysis: "Lancer l'Analyse",
  regenerateSummary: "Régénérer le résumé",
  addApiKeyFirst: "Ajouter d'abord une clé API",
  advancedInsightsComingSoon: "Insights Avancés Bientôt Disponibles",
  advancedInsightsDesc: "Analyse IA approfondie du sentiment et des tendances.",
  endSessionDesc:
    "Mettre fin à la session vous permet de recueillir des commentaires. Les participants ne pourront plus poser de nouvelles questions.",

  // FeedbackView
  ratePrompt: "Comment évaluez-vous cette présentation ?",
  keyTakeaway: "Un point clé à retenir ?",
  submitSeeCheatSheet: "Envoyer & Voir le Résumé →",
  submitFeedbackBtn: "Envoyer Feedback",
  skipStep: "Passer cette étape",
  unlocked: "DÉVERROUILLÉ",
  sessionLockedAlert:
    "La session est verrouillée. Aucune nouvelle question autorisée.",
  questionLimitReached:
    "Vous avez atteint votre limite de questions pour cette session.",
  submitError:
    "Échec de l'envoi de la question. Veuillez vérifier votre connexion.",
  sessionIsLocked: "La session est verrouillée",
  generatingAiSummary: "L'IA générative résume la session…",
  savedToClipboard: "Copié dans le presse-papier !",
  copySummary: "Copier le Résumé",
  screenshotsEncouraged: "Captures d'écran encouragées ! 📸",
  feedbackSubmitted: "Votre avis a été envoyé avec succès.",

  // ParticipantList
  onlineCount: "En ligne",
  anonymous: "Anonyme",
  noParticipants: "Personne d'autre ici pour l'instant.",
  joinedAt: "Rejoint",

  // QuestionCard
  pinned: "Épinglé",
  onHold: "En Attente",
  waitingApproval: "En attente d'approbation…",
  rejected: "Rejeté",
  questionBlocked: "Question bloquée : contenu inapproprié.",
  editedFrom: "Modifié de :",
  ownQuestionVoteError: "Vous ne pouvez pas voter pour votre propre question",
  upvoteAria: "Voter pour la question, nombre actuel",
  voteCount: "Nombre de votes",
  markPending: "Marquer comme en attente",
  markAnsweredDone: "Marquer comme répondu",
  markDone: "Fait",
  markDoneShort: "Marquer Fait",
  removeFromFavorites: "Retirer des favoris",
  addToFavorites: "Ajouter aux favoris",
  unpinQuestion: "Désépingler la question",
  pinQuestion: "Épingler la question",

  // PresenterDashboard & LandingPage
  slideNum: "Diapo",
  supportsFiles: "Supporte Images (JPG, PNG) et PDF",
  addBtn: "Ajouter",
  slideProcessing: "Traitement",
  deleteSlide: "Supprimer la diapo",
  deleteSlideConfirm: "Supprimer cette diapo ? Cette action est irréversible.",
  liveIndicator: "EN DIRECT",
  aiReady: "IA Prête",
  newCount: "nouveau",
  unrelatedQuestions: "Non lié à des diapositives spécifiques",
  generalQuestionsDesc:
    "Questions que l'IA n'a pas pu lier à une diapositive spécifique.",
  archivedStatus: "Archivé",
  all: "Tout",
  signOut: "Déconnexion",
  signInRequired: "Veuillez vous connecter pour soumettre une demande.",
  newSession: "Nouvelle Session",
  joinExisting: "Rejoindre l'existant",
  lightTheme: "Clair",
  darkTheme: "Mode Sombre",
  systemTheme: "Système",
  auroraEffect: "Effet Aurore",
  auroraEffectDesc: "Animations de fond dynamiques",
  statusLive: "En Direct",
  limitLabel: "Limite",
  pinCodeLabel: "Code PIN",
  changesSaved: "Modifications enregistrées avec succès !",
  votesLabel: "Votes",
  pressEnter: "Appuyez sur Entrée",
  enterKey: "Entrée",
  confirm: "Confirmer",
  delete: "Supprimer",
  confirmDelete: "Êtes-vous sûr de vouloir supprimer cette demande ?",
  supportDeleteFailed: "Échec de la suppression de la demande. Veuillez réessayer.",
  copied: "Copié !",
  confirmAccessControlChange: "L'activation du contrôle d'accès peut déconnecter les participants actuels. Êtes-vous sûr de vouloir continuer ?",
  idShort: "ID :",
  enterPinPlaceholder: "Entrez le PIN à 6 chiffres...",
  maxSessionsReached: "Vous avez atteint le nombre maximum de sessions. Veuillez archiver ou supprimer les anciennes.",
  smartSuggestion: "Suggestions Intelligentes",
  smartSuggestionDesc: "Aidez votre public à poser de meilleures questions. Notre IA suggère des améliorations.",
  aiAnalysisPrefix: "Analyse IA :",
  analyzingSlides: "Analyse des diapositives avec l'IA...",
  analyzedSlideProgress: "Diapositive analysée",
  processingFiles: "Traitement des fichiers...",
  pdfProcessError: "Impossible de traiter le PDF :",
  uploadingProgress: "Téléchargement",
  noQuestionsSlide: "Pas encore de questions sur cette diapositive.",
  fileTooLarge: "Fichier trop volumineux.",
  maxSize: "(Max {0} Mo)",
  unsupportedFiles: "Certains fichiers ne sont pas supportés. Autorisés : {0}",
  filesSelected: "{0} fichiers sélectionnés",

  // User Dashboard
  myDashboard: "Mon Tableau de bord",
  editProfile: "Modifier le profil",
  profile: "Profil",
  sessionHistory: "Historique des sessions",
  updateProfile: "Mettre à jour le profil",
  displayName: "Nom d'affichage",
  photoUrl: "URL de la photo",
  saveProfile: "Enregistrer le profil",
  profileUpdated: "Profil mis à jour avec succès",
  noSessions: "Aucune session trouvée",
  createFirstSession: "Créez votre première session pour commencer !",
  viewSession: "Voir la session",
  sessions: "Sessions",
  joined: "Rejoint",
  created: "Créé",

  // New Dashboard Keys
  welcomeBack: "Bon retour",
  totalSessions: "Sessions",
  activeSessions: "Sessions Actives",
  yourSessions: "Vos Sessions",
  manageSessionsSubtitle: "Gérez et surveillez vos canaux de feedback",
  readyToStart: "Prêt à commencer ?",
  creating: "Création",
  logout: "Déconnexion",
  activeSessionDetected: "Session Active Détectée",
  archivePrompt:
    "Vous avez une session en direct. Vous devez l'archiver pour en commencer une nouvelle.",
  returnToLiveSessionPrompt: "Vous avez une session en cours.",
  archiveAndCreate: "Archiver et Créer",
  archiveAndCreateNew: "Archiver et Créer Une Nouvelle",
  returnToSession: "Retour à la Session",
  or: "OU",
  errorArchiving: "Erreur d'archivage de session",
  errorUploadingSlide: "Erreur de téléchargement de diapo. Session créée sans.",
  geminiApiKey: "Clé API Gemini",
  geminiApiKeyPlaceholder: "Entrez votre clé API Gemini",
  geminiPrivacyNote: "Votre clé est stockée localement dans votre navigateur et n'est jamais envoyée à nos serveurs.",
  aiStatusActive: "IA Active",
  aiStatusInactive: "IA Inactive",
  aiActiveBenefit: "Regroupement intelligent et résumés prêts.",
  aiInactiveAction: "Ajoutez une clé pour débloquer l'IA",
  getKeyLink: "Obtenez une clé Gemini gratuite",
  sessionNoAiPower: "Remarque : Votre session n'aura pas de puissance IA car l'API n'est pas activée.",
  backToDashboard: "Retour au Tableau de Bord",
  manageYourSettings: "Gérez vos préférences globales et votre configuration IA",
  appPreferences: "Préférences de l'App",
  aiConfigurationMoved: "Configuration IA déplacée",
  aiConfigurationMovedDesc: "Les paramètres Gemini IA sont désormais globaux. Vous pouvez gérer votre clé API pour toutes les sessions en un seul endroit.",
  goToUserSettings: "Aller aux Paramètres Utilisateur",
  manageAiKeysInSettings: "Gérez vos clés API Gemini dans les paramètres globaux",
  goToSettings: "Aller aux Paramètres",
  aiConfiguration: "Configuration IA",
  sessionEndedReadOnly: "Session terminée (Lecture seule)",

  // Tour
  tourViewSwitcherTitle: "Sélecteur de Vue",
  tourViewSwitcherDesc: "Basculez entre la Vue Présentateur (tableau de bord) et la Vue Audience (ce que voient les utilisateurs).",
  tourLiveFeedTitle: "Flux en Direct",
  tourLiveFeedDesc: "Surveillez les questions entrantes de l'audience en temps réel. Mettez-les en favori, épinglez-les ou marquez-les comme répondues.",
  tourSlideSyncTitle: "Synchro des Diapos",
  tourSlideSyncDesc: "Téléchargez vos diapositives de présentation pour regrouper automatiquement les questions entrantes par diapositive.",
  tourAiInsightsTitle: "Aperçus de l'IA",
  tourAiInsightsDesc: "Utilisez Gemini 3 Pro pour générer des résumés, analyser le sentiment et repérer instantanément les sujets tendance.",
  tourFeedbackLoopTitle: "Boucle de Rétroaction",
  tourFeedbackLoopDesc: "Lorsque vous terminez votre session, passez à cet onglet pour recueillir les notes de l'audience et les points clés à retenir avant de fermer.",
  tourSettingsTitle: "Paramètres et Clé API",
  tourSettingsDesc: "Configurez les options de votre session et entrerez votre clé API Gemini ici pour activer les fonctionnalités de l'IA.",
  tourJoinCodeTitle: "Code d'Accès",
  tourJoinCodeDesc: "Cliquez ici pour afficher le code QR et l'identifiant de la session pour que votre public puisse la rejoindre.",

  // CSV Export
  author: "Auteur",
  text: "Texte",
  topic: "Sujet",
  upvotes: "Votes",
  status: "Statut",
  timestamp: "Horodatage",
  toggleParticipantList: "Basculer la liste des participants",
  rateStarAria: "Noter {0} sur 5",
  copyToClipboardAria: "Copier le résumé dans le presse-papiers",
};

const zh = {
  appTitle: "VoxPop AI",
  appDesc: "实时观众互动",
  startSession: "开始问答会话",
  joinSession: "通过 ID 加入",
  orJoin: "或加入现有会话",
  setupSession: "设置会话",
  configureChannel: "配置您的问答频道",
  sessionTitle: "会话标题",
  descOptional: "描述 (可选)",
  maxQuestions: "每人最大提问数",
  accessControl: "访问控制",
  protected: "受保护",
  public: "公开",
  optional: "可选",
  requiresPin: "需要 PIN",
  requireLogin: "要求使用 Google 登录",
  requireLoginDesc: "观众需先使用 Google 登录才能加入。",
  freeToJoin: "免费加入",
  addDescriptionPrompt: "添加描述以帮助 AI 理解背景...",
  uploadSlidePrompt: "上传演示文稿以引导观众...",
  uploadSlideBtn: "上传演示文稿",
  optionalEncouragement: "可选，但建议添加以获得更好的 AI 效果。",
  cancel: "取消",
  close: "关闭",
  createChannel: "创建频道",
  joinTitle: "欢迎！",
  joining: "正在加入",
  yourName: "您的名字",
  leaveBlank: "留空以使用",
  joinBtn: "加入会话",
  loginRequiredTitle: "登录后加入",
  loginRequiredDesc: "此会话要求先使用 Google 登录。",
  continueWithGoogle: "使用 Google 继续",
  signedInAs: "已登录为",
  recent: "最新",
  popular: "最热",
  mine: "我的提问",
  noQuestions: "暂无问题",
  typeQuestion: "输入问题...",
  askingDisabled: "提问已禁用",
  postAs: "发布身份",
  left: "剩余",
  liveFeed: "实时动态",
  analytics: "分析",
  insights: "AI 洞察",
  exportCSV: "导出 CSV",
  endSession: "结束会话",
  sessionEnded: "会话已结束",
  joinCode: "加入代码",
  showQR: "显示二维码",
  trendingTopics: "热门话题",
  engagement: "参与度",
  active: "活跃",
  passive: "被动",
  aiAnalysisReady: "AI 分析就绪",
  generateInsights: "生成实时洞察",
  addApiKey: "添加 API 密钥以启用 AI",
  removeApiKeyTitle: "移除 API 密钥？",
  removeApiKeyConfirm: "在保存新密钥之前，AI 功能将停止工作。",
  removeApiKeyAction: "移除密钥",
  refreshAnalysis: "刷新分析",
  online: "在线",
  activeParticipants: "活跃参与者",
  markAnswered: "标记为已答",
  answered: "已回答",
  hide: "隐藏",
  unhide: "取消隐藏",
  favorite: "收藏",
  pin: "置顶",
  analyzing: "正在分析...",
  autoGroup: "自动分组",
  checkGrammar: "检查语法",
  reanalyze: "重新分析",
  checking: "检查中...",
  aiSuggestion: "AI 建议",
  applyChange: "应用更改",
  dismiss: "忽略",
  questions: "问题",
  endSessionConfirmTitle: "结束会话？",
  endSessionConfirmBody: "这将永久关闭会话。参与者将断开连接。您将返回主屏幕。",
  confirmEnd: "是的，结束会话",
  sessionUnavailable: "会话不可用",
  createError: "创建会话失败。请重试。",
  error: "错误",
  sessionEndedMessage: "此问答会话已结束。",
  backToHome: "返回首页",
  aiPriorityEx: "分数基于语法、清晰度和话题相关性计算。",
  presentationMode: "演示模式",
  startPresentation: "开始演示",
  presenting: "演示中",
  noQuestionsFilter: "此过滤器下无问题",
  exitPresentation: "退出演示",
  next: "下一个",
  prev: "上一个",
  shortcuts: "快捷键",
  markAnsweredShort: "标记已答",
  keyboardHint: "使用 ← → 导航，Enter 回答，Esc 退出",

  slides: "幻灯片同步",
  uploadSlides: "上传幻灯片",
  uploadSlidesDesc: "上传演示文稿（图片）以按幻灯片分组问题。",
  uploadBtn: "选择图片",
  processingSlides: "处理幻灯片...",
  generalQuestions: "常规 / 其他",
  currentSlide: "当前幻灯片",
  setAsCurrent: "设为当前",
  questionsForSlide: "此幻灯片的问题",

  softCloseTitle: "总结会话？",
  softCloseBody: "您可以进入“反馈模式”停止提问并请求评分。或立即结束。",
  startFeedback: "开始反馈模式",
  skipFeedback: "跳过反馈并结束",
  endImmediately: "立即结束",
  feedbackMode: "反馈模式",
  feedbackLive: "反馈进行中",
  feedbackLocked: "反馈已锁定",
  feedbackLockedDesc: "启动反馈模式，允许观众评估并解锁其作弊表。",
  startFeedbackMode: "启动反馈模式",
  finalResults: "最终结果",
  responded: "已响应",
  participantsLabel: "参与者",
  liveComments: "实时评论",
  waitingForComments: "等待评论...",
  noComment: "未提供评论",
  waitingForFeedback: "等待观众反馈...",
  analyzeSentiment: "分析情感",
  reanalyzeSentiment: "重新分析情感",
  averageRating: "平均评分",
  netScore: "会话得分",
  archiveSession: "归档并关闭",
  rateSession: "评价此会话",
  feedbackPlaceholder: "您的主要收获是什么？（可选）",
  submitFeedback: "提交反馈",
  thankYou: "谢谢！",
  aiTakeawayTitle: "您的 AI 会话备忘录",
  aiTakeawayDesc: "VoxPop 分析了会话并为您生成了此摘要。",
  generatingTakeaway: "正在生成摘要...",
  generateTakeawayDesc: "为您的观众生成幻灯片和问答的简明摘要。",
  generateBtn: "生成",
  updating: "正在更新...",
  copy: "复制",
  feedbackReport: "反馈报告",
  exitSession: "退出会话",
  remove: "移除",

  // Support Requests
  supportCenter: "支持中心",
  supportCenterDesc:
    "发送功能请求或错误报告。可以在此处附加文件并跟踪状态。",
  requestType: "请求类型",
  requestTypeFeature: "功能请求",
  requestTypeBug: "错误报告",
  requestTitle: "标题",
  requestTitlePlaceholder: "简短摘要",
  requestDescription: "详情",
  requestDescriptionPlaceholder: "步骤、预期行为和背景。",
  attachments: "附件",
  submitRequest: "提交请求",
  submitting: "正在提交...",
  requestStatus: "您的请求",
  noSupportRequests: "尚未提交任何请求。",
  supportStatusSubmitted: "已提交",
  supportStatusInReview: "审核中",
  supportStatusPlanned: "已计划",
  supportStatusInProgress: "正在进行",
  supportStatusResolved: "已解决",
  supportStatusRejected: "已拒绝",
  supportFormError: "请添加标题和描述。",
  supportSubmitFailed: "提交请求失败。请重试。",
  supportResponseNote: "您可以随时添加更多请求。",
  delete: "删除",
  confirmDelete: "您确定要删除此支持请求吗？",
  confirm: "确认",
  supportDeleteFailed: "删除请求失败。请重试。",

  tourMobileSettingsTitle: "设置与操作",
  tourMobileSettingsDesc: "在此处访问会话设置。您还可以在此菜单中找到二维码、导出 CSV 和结束会话按钮。",
  sessionActions: "会话操作",

  // Landing Page
  heroTitle: "将观众的沉默转化为实时的洞察。",
  heroSubtitle:
    "由 AI 驱动的问答平台，可立即主持、分组和总结观众问题。参与者无需登录。",
  features: "功能特性",
  howItWorks: "工作原理",
  presenterLogin: "讲师登录",
  goToDashboard: "前往控制面板",
  dashboardLabel: "儀表板",
  newPresentationMode: "新功能：交互式演示模式",
  superchargedByGemini: "由 Gemini 3 Pro 提供强大支持",
  aiEngineDesc:
    "我们不仅仅是收集问题。我们理解它们。我们的 AI 引擎可以对话题进行分组，过滤噪音，并优先处理重要事务。",
  semanticGrouping: "语义分组",
  semanticGroupingDesc:
    "十个人以不同的方式询问关于“远程工作”的问题？VoxPop 能识别出这是一个核心话题，让您的问答环节保持整洁且聚焦。",
  slideSyncDesc: "上传您的幻灯片。问题会自动标记到屏幕上显示的幻灯片。",
  liveInsights: "实时洞察",
  liveInsightsDesc: "在演讲时实时掌握观众的情绪和参与程度。",
  feedbackModeDesc:
    "通过请求评分和核心收获来总结您的会话。VoxPop 为每个人生成一份文本总结以便留存。",
  seeDemo: "查看演示",
  effortlessTitle: "对每个人来说都毫不费力",
  createSession: "创建会话",
  createSessionDesc: "主持人可在数秒内设置好频道。无需复杂的配置。",
  audienceJoinsQR: "通过二维码加入",
  audienceJoinsQRDesc: "无需下载应用。无需登录。只需对准摄像头即可开始提问。",
  aiModeratesGroups: "AI 主持与分组",
  aiModeratesGroupsDesc: "问题显示在主持人的控制面板上，按话题和重要性组织。",
  readyToEngage: "准备好互动了吗？",
  readyToEngageDesc:
    "加入成千上万使用 VoxPop 的讲师行列，让他们的环节令人难忘。",
  getStartedFree: "免费开始使用",
  noCreditCardDesc: "无需信用卡。永久免费。",
  buyMeCoffee: "请我喝咖啡",

  sessionPlaceholder: "例如：Q4 全体会议",
  geminiAnalysis: "Gemini 分析",
  problemHeading: "为何现场问答体验糟糕",
  frictionlessTitle: "无摩擦参与",
  knowAudienceTitle: "了解您的观众",
  high: "高",
  featGrammar: "语法修复",
  featProfanity: "脏话过滤",
  featTopic: "话题标签",
  featGrouping: "智能分组",
  mockPricing: "定价",
  mockAPI: "API",
  mockSecurity: "安全",
  footerText: "© 2024 VoxPop AI. 由 Gemini 3 Pro 驱动。",
  joinInstruction: "输入主持人提供的 8 位代码。",
  tapToAsk: "点击下方提问！",

  settings: "设置",
  appearance: "外观",
  language: "语言",
  theme: "主题",
  sessionDetails: "会话详情",
  participation: "参与",
  participants: "参与者",
  saveChanges: "保存更改",
  saving: "保存中...",

  aiFeaturesDisabled: "AI 功能已禁用",
  enableAiFeatures: "请在设置中添加 Gemini API 密钥以启用 AI 功能。",
  aiWarningTitle: "AI 警告",
  aiTokenPreconditionMessage:
    "AI 功能暂时不可用（412）。如果你是演讲者，请在设置中检查 Gemini API 密钥，确保已启用并开通计费，然后重试。",
  aiQuotaExceededMessage:
    "AI 配额或速率限制已达上限。请稍后再试，或检查 Gemini 计划与计费。",
  welcome: "欢迎",
  setupPrompt:
    "让我们为您设置 VoxPop AI。我们需要 API 密钥来通过 AI 提供支持。",
  activateAi: "激活",
  activateAiDesc:
    "VoxPop 使用 Google Gemini 生成摘要、分析问题并赋予您演讲超能力。",
  getStarted: "开始使用",
  enterGeminiKey: "输入 Gemini API 密钥",
  keyStoredLocally: "您的密钥已加密并存储在本地。我们无法查看。",
  needKeyPrompt: "需要密钥？免费获取于",
  saveContinue: "保存并继续",
  viewPresenter: "演讲者",
  viewAudience: "观众",
  loading: "加载中...",
  incorrectPin: "PIN 码错误",
  errorValidatingPin: "验证 PIN 码时出错",
  sessionId: "会话 ID",
  sessionIdPlaceholder: "例如 A1B2-C3D4…",
  copyJoinLink: "复制加入链接",
  analyticsInsights: "分析与洞察",
  popularTopics: "热门话题",
  aiConsultant: "AI 顾问",
  aiConsultantDesc: "分析问题以发现模式并总结会话。",
  runAnalysis: "运行分析",
  regenerateSummary: "重新生成摘要",
  addApiKeyFirst: "先添加 API 密钥",
  advancedInsightsComingSoon: "高级洞察即将推出",
  advancedInsightsDesc: "深入分析 AI 对情绪和参与度的趋势。",
  endSessionDesc: "结束会话允许您收集反馈。参与者将无法提出新问题。",

  // FeedbackView
  ratePrompt: "您如何评价这个演示？",
  keyTakeaway: "一个主要收获？",
  submitSeeCheatSheet: "提交并查看备忘录 →",
  submitFeedbackBtn: "提交反馈",
  skipStep: "跳过此步骤",
  unlocked: "已解锁",
  sessionLockedAlert: "会话已锁定。不允许提出新问题。",
  questionLimitReached: "您已达到本次会话的提问限制。",
  submitError: "提交问题失败。请检查您的网络连接。",
  sessionIsLocked: "会话已锁定",
  generatingAiSummary: "生成式 AI 正在总结会话…",
  savedToClipboard: "已保存到剪贴板！",
  copySummary: "复制摘要",
  screenshotsEncouraged: "欢迎截图！📸",
  feedbackSubmitted: "您的反馈已成功提交。",

  // ParticipantList
  onlineCount: "在线",
  anonymous: "匿名",
  noParticipants: "此处暂无其他人。",
  joinedAt: "加入于",

  // QuestionCard
  pinned: "已置顶",
  onHold: "搁置",
  waitingApproval: "等待批准…",
  rejected: "已拒绝",
  questionBlocked: "问题已屏蔽：检测到不当内容。",
  editedFrom: "编辑自：",
  ownQuestionVoteError: "您不能给自己的问题投票",
  upvoteAria: "投票问题，当前计数",
  voteCount: "票数",
  markPending: "标记为待处理",
  markAnsweredDone: "标记为已回答",
  markDone: "完成",
  markDoneShort: "标记完成",
  removeFromFavorites: "从收藏中移除",
  addToFavorites: "添加到收藏",
  unpinQuestion: "取消置顶问题",
  pinQuestion: "置顶问题",

  // PresenterDashboard & LandingPage
  slideNum: "幻灯片",
  supportsFiles: "支持图片 (JPG, PNG) 和 PDF",
  addBtn: "添加",
  slideProcessing: "处理中",
  deleteSlide: "删除幻灯片",
  deleteSlideConfirm: "删除此幻灯片？此操作无法撤销。",
  liveIndicator: "直播",
  aiReady: "AI 就绪",
  newCount: "新",
  unrelatedQuestions: "与特定幻灯片无关",
  generalQuestionsDesc: "AI 无法链接到特定幻灯片的问题。",
  archivedStatus: "已归档",
  all: "全部",
  signOut: "退出登录",
  signInRequired: "請登錄以提交請求。",
  newSession: "新会话",
  joinExisting: "加入现有",
  lightTheme: "浅色",
  darkTheme: "深色模式",
  systemTheme: "系统默认",
  auroraEffect: "极光效果",
  auroraEffectDesc: "动态效果背景动画",
  statusLive: "直播",
  limitLabel: "限制",
  pinCodeLabel: "PIN 码",
  changesSaved: "更改已成功保存！",
  votesLabel: "票数",
  pressEnter: "按 Enter",
  enterKey: "Enter",
  copied: "已复制！",
  confirmAccessControlChange: "启用访问控制可能会断开当前参与者的连接。您确定要继续吗？",
  idShort: "ID：",
  enterPinPlaceholder: "输入 6 位 PIN 码...",
  smartSuggestion: "智能建议",
  smartSuggestionDesc: "帮助您的观众提出更好的问题。我们的 AI 会根据金字塔原则提供建议。",
  aiAnalysisPrefix: "AI 分析：",
  analyzingSlides: "正在使用 AI 分析幻灯片...",
  analyzedSlideProgress: "已分析幻灯片",
  processingFiles: "正在处理文件...",
  pdfProcessError: "无法处理 PDF：",
  uploadingProgress: "正在上传",
  noQuestionsSlide: "此幻灯片尚无提问。",
  fileTooLarge: "文件太大。",
  maxSize: "（最大 {0}MB）",
  unsupportedFiles: "某些文件不受支持。允许：{0}",
  filesSelected: "已选择 {0} 个文件",
  toggleParticipantList: "切换活动参与者列表",
  rateStarAria: "评分为 {0}（满分 5 星）",
  copyToClipboardAria: "将摘要复制到剪贴板",

  // User Dashboard
  myDashboard: "我的控制台",
  editProfile: "编辑个人资料",
  profile: "个人资料",
  sessionHistory: "历史会话",
  updateProfile: "更新资料",
  displayName: "显示名称",
  photoUrl: "头像 URL",
  saveProfile: "保存资料",
  profileUpdated: "资料更新成功",
  noSessions: "未找到会话",
  createFirstSession: "创建您的第一个会话以开始！",
  viewSession: "查看会话",
  sessions: "会话",
  joined: "已加入",
  created: "已创建",

  // New Dashboard Keys
  welcomeBack: "欢迎回来",
  totalSessions: "会话",
  activeSessions: "活跃会话",
  yourSessions: "您的会话",
  manageSessionsSubtitle: "管理和监控您的观众反馈频道",
  readyToStart: "准备开始了吗？",
  creating: "正在创建",
  logout: "退出登录",
  activeSessionDetected: "检测到活动会话",
  archivePrompt:
    "您当前有一个进行中的会话。在开始新会话之前，您必须先将其归档。",
  returnToLiveSessionPrompt: "您有一个正在进行的会话。",
  archiveAndCreateNew: "归档并创建新会话",
  returnToSession: "返回直播会话",
  or: "或",
  archiveAndCreate: "归档并创建",
  errorArchiving: "归档会话出错",
  errorUploadingSlide: "上传幻灯片出错。会话已创建但不含此片。",
  geminiApiKey: "Gemini API 密钥",
  geminiApiKeyPlaceholder: "输入您的 Gemini API 密钥",
  geminiPrivacyNote: "您的密钥存储在本地浏览器中，绝不会发送到我们的服务器。",
  aiStatusActive: "AI 已激活",
  aiStatusInactive: "AI 未激活",
  aiActiveBenefit: "智能分组和摘要已就绪。",
  aiInactiveAction: "添加密钥以解锁 AI 功能",
  getKeyLink: "免费获取 Gemini 密钥",
  sessionNoAiPower: "注意：由于 API 未激活，您的会话将不支持 AI 功能。",
  backToDashboard: "返回控制面板",
  manageYourSettings: "管理您的全局偏好和 AI 配置",
  appPreferences: "应用设置",
  aiConfigurationMoved: "AI 配置已移动",
  aiConfigurationMovedDesc: "Gemini AI 设置现已全局化。您可以在一个地方管理所有会话的 API 密钥。",
  goToUserSettings: "前往用户设置",
  manageAiKeysInSettings: "在全局设置中管理您的 Gemini API 密钥",
  goToSettings: "前往设置",
  aiConfiguration: "AI 配置",
  sessionEndedReadOnly: "会话已结束（只读）",
  maxSessionsReached: "您已达到会话数量上限。请归档或删除旧会话以创建新会话。",

  // Tour
  tourViewSwitcherTitle: "视图切换器",
  tourViewSwitcherDesc: "在讲师视图（控制面板）和观众视图（用户看到的内容）之间切换。",
  tourLiveFeedTitle: "实时信息流",
  tourLiveFeedDesc: "实时监控观众提出的问题。收藏、置顶或将其标记为已回答。",
  tourSlideSyncTitle: "幻灯片同步",
  tourSlideSyncDesc: "上传您的演示幻灯片，以便按幻灯片自动对收到的问题进行分组。",
  tourAiInsightsTitle: "AI 洞察",
  tourAiInsightsDesc: "使用 Gemini 3 Pro 立即生成摘要、分析情感并发现热门话题。",
  tourFeedbackLoopTitle: "反馈循环",
  tourFeedbackLoopDesc: "结束会话时，切换到此标签以在关闭前收集观众评分和关键要点。",
  tourSettingsTitle: "设置与 API 密钥",
  tourSettingsDesc: "在此处配置您的会话选项并输入您的 Gemini API 密钥以启用 AI 功能。",
  tourJoinCodeTitle: "加入代码",
  tourJoinCodeDesc: "点击此处显示二维码和会话 ID，供您的观众加入。",

  // CSV Export
  author: "作者",
  text: "文本",
  topic: "话题",
  upvotes: "投票",
  status: "状态",
  timestamp: "时间戳",
};

const hi = {
  appTitle: "VoxPop AI",
  appDesc: "वास्तविक समय दर्शक जुड़ाव",
  startSession: "सत्र शुरू करें",
  joinSession: "ID के माध्यम से जुड़ें",
  orJoin: "या मौजूदा में शामिल हों",
  setupSession: "सत्र सेटअप",
  configureChannel: "अपना Q&A चैनल कॉन्फ़िगर करें",
  sessionTitle: "सत्र शीर्षक",
  descOptional: "विवरण (वैकल्पिक)",
  maxQuestions: "अधिकतम प्रश्न/उपयोगकर्ता",
  accessControl: "पहुँच नियंत्रण",
  protected: "सुरक्षित",
  public: "सार्वजनिक",
  optional: "वैकल्पिक",
  requiresPin: "पिन आवश्यक",
  requireLogin: "Google लॉगिन आवश्यक",
  requireLoginDesc: "जुड़ने से पहले दर्शकों को Google से साइन इन करना होगा।",
  freeToJoin: "जुड़ने के लिए स्वतंत्र",
  addDescriptionPrompt: "AI को संदर्भ समझने में मदद करने के लिए एक विवरण जोड़ें...",
  uploadSlidePrompt: "अपने दर्शकों का मार्गदर्शन करने के लिए एक प्रस्तुति अपलोड करें...",
  uploadSlideBtn: "प्रस्तुति अपलोड करें",
  optionalEncouragement: "वैकल्पिक, लेकिन बेहतर AI परिणामों के लिए अनुशंसित।",
  cancel: "रद्द करें",
  close: "बंद करें",
  createChannel: "चैनल बनाएँ",
  joinTitle: "स्वागत है!",
  joining: "आप शामिल हो रहे हैं",
  yourName: "आपका नाम",
  leaveBlank: "उपयोग करने के लिए खाली छोड़ें",
  joinBtn: "सत्र में शामिल हों",
  loginRequiredTitle: "जुड़ने के लिए साइन इन करें",
  loginRequiredDesc: "इस सत्र में शामिल होने के लिए Google साइन इन आवश्यक है।",
  continueWithGoogle: "Google के साथ जारी रखें",
  signedInAs: "के रूप में साइन इन",
  recent: "हालिया",
  popular: "लोकप्रिय",
  mine: "मेरे प्रश्न",
  noQuestions: "अभी तक कोई प्रश्न नहीं",
  typeQuestion: "एक प्रश्न टाइप करें...",
  askingDisabled: "पूछना अक्षम है",
  postAs: "इस रूप में पोस्ट करें",
  left: "बचे हैं",
  liveFeed: "लाइव फीड",
  analytics: "एनालिटिक्स",
  insights: "AI अंतर्दृष्टि",
  exportCSV: "CSV निर्यात करें",
  endSession: "सत्र समाप्त करें",
  sessionEnded: "सत्र समाप्त हो गया",
  joinCode: "जुड़ने का कोड",
  showQR: "QR दिखाएं",
  trendingTopics: "ट्रेंडिंग विषय",
  engagement: "जुड़ाव",
  active: "सक्रिय",
  passive: "निष्क्रिय",
  aiAnalysisReady: "AI विश्लेषण तैयार",
  generateInsights: "लाइव अंतर्दृष्टि उत्पन्न करें",
  addApiKey: "AI सक्षम करने के लिए API कुंजी जोड़ें",
  removeApiKeyTitle: "API कुंजी हटाएं?",
  removeApiKeyConfirm: "नई कुंजी सहेजने तक AI फीचर काम नहीं करेंगे।",
  removeApiKeyAction: "कुंजी हटाएं",
  refreshAnalysis: "विश्लेषण ताज़ा करें",
  online: "ऑनलाइन",
  activeParticipants: "सक्रिय प्रतिभागी",
  markAnswered: "उत्तर दिया गया चिह्नित करें",
  answered: "उत्तर दिया गया",
  hide: "छिपाएँ",
  unhide: "दिखाएँ",
  favorite: "पसंदीदा",
  pin: "शीर्ष पर पिन करें",
  analyzing: "विश्लेषण कर रहा है...",
  autoGroup: "विषय समूह",
  checkGrammar: "व्याकरण जाँचें",
  reanalyze: "पुनः विश्लेषण",
  checking: "जाँच रहा है...",
  aiSuggestion: "AI सुझाव",
  applyChange: "परिवर्तन लागू करें",
  dismiss: "खारिज करें",
  questions: "प्रश्न",
  endSessionConfirmTitle: "सत्र समाप्त करें?",
  endSessionConfirmBody: "यह सत्र को स्थायी रूप से बंद कर देगा।",
  confirmEnd: "हाँ, समाप्त करें",
  sessionUnavailable: "सत्र अनुपलब्ध",
  createError: "सत्र बनाने में विफल।",
  error: "त्रुटि",
  sessionEndedMessage: "यह Q&A सत्र समाप्त हो गया है।",
  backToHome: "होम पर वापस जाएँ",
  aiPriorityEx: "स्कोर व्याकरण, स्पष्टता और प्रासंगिकता पर आधारित है।",
  analyticsInsights: "एनालिटिक्स और अंतर्दृष्टि",
  popularTopics: "लोकप्रिय विषय",
  aiConsultant: "AI सलाहकार",
  aiConsultantDesc: "पैटर्न खोजने और सत्र को सारांशित करने के लिए प्रश्नों का विश्लेषण करें।",
  runAnalysis: "विश्लेषण चलाएँ",
  regenerateSummary: "सारांश फिर से जनरेट करें",
  addApiKeyFirst: "पहले API कुंजी जोड़ें",
  advancedInsightsComingSoon: "उन्नत अंतर्दृष्टि जल्द ही आ रही है",
  advancedInsightsDesc: "भावनाओं और जुड़ाव के रुझानों का गहरा AI विश्लेषण।",
  endSessionDesc: "सत्र समाप्त करने से आप फीडबैक एकत्र कर सकते हैं। प्रतिभागी नए प्रश्न नहीं पूछ पाएंगे।",
  presentationMode: "प्रस्तुति मोड",
  startPresentation: "प्रस्तुति शुरू करें",
  presenting: "प्रस्तुत कर रहा है",
  noQuestionsFilter: "कोई प्रश्न नहीं",
  exitPresentation: "प्रस्तुति से बाहर निकलें",
  next: "अगला",
  prev: "पिछला",
  shortcuts: "शॉर्टकट",
  markAnsweredShort: "उत्तर दिया गया",
  keyboardHint: "नेविगेट करने के लिए ← → का उपयोग करें",

  slides: "स्लाइड-सिंक्ड",
  uploadSlides: "स्लाइड अपलोड करें",
  uploadSlidesDesc: "प्रस्तुति अपलोड करें",
  uploadBtn: "छवियाँ चुनें",
  processingSlides: "स्लाइड संसाधित हो रही हैं...",
  generalQuestions: "सामान्य",
  currentSlide: "वर्तमान स्लाइड",
  setAsCurrent: "वर्तमान के रूप में सेट करें",
  questionsForSlide: "स्लाइड के लिए प्रश्न",

  softCloseTitle: "सत्र को समेटें?",
  softCloseBody: "फीडबैक मोड शुरू करें या तुरंत समाप्त करें।",
  startFeedback: "फीडबैक मोड शुरू करें",
  skipFeedback: "फीडबैक छोड़ें और समाप्त करें",
  endImmediately: "तुरंत समाप्त करें",
  feedbackMode: "फीडबैक मोड",
  feedbackLive: "फीडबैक लाइव है",
  feedbackLocked: "फीडबैक लॉक है",
  feedbackLockedDesc: "दर्शकों को सत्र रेट करने और उनकी चीट शीट अनलॉक करने के लिए फीडबैक मोड शुरू करें।",
  startFeedbackMode: "फीडबैक मोड शुरू करें",
  finalResults: "अंतिम परिणाम",
  responded: "प्रतिक्रिया दी",
  participantsLabel: "प्रतिभागी",
  liveComments: "लाइव टिप्पणियाँ",
  waitingForComments: "टिप्पणियों की प्रतीक्षा है...",
  noComment: "कोई टिप्पणी नहीं दी गई",
  waitingForFeedback: "फीडबैक की प्रतीक्षा है...",
  analyzeSentiment: "भावना विश्लेषण",
  reanalyzeSentiment: "पुनः भावना विश्लेषण",
  averageRating: "औसत रेटिंग",
  netScore: "सत्र स्कोर",
  archiveSession: "पुरालेख और बंद करें",
  rateSession: "इस सत्र को रेट करें",
  feedbackPlaceholder: "आपका मुख्य निष्कर्ष क्या था?",
  submitFeedback: "फीडबैक सबमिट करें",
  thankYou: "धन्यवाद!",
  aiTakeawayTitle: "आपका AI सत्र सारांश",
  aiTakeawayDesc: "VoxPop ने आपके लिए यह सारांश तैयार किया है।",
  generatingTakeaway: "सारांश तैयार हो रहा है...",
  generateTakeawayDesc: "अपने दर्शकों के लिए स्लाइड और Q&A का संक्षिप्त सारांश तैयार करें।",
  generateBtn: "जनरेट",
  updating: "अपडेट हो रहा है...",
  copy: "कॉपी",
  feedbackReport: "फीडबैक",
  exitSession: "सत्र से बाहर निकलें",
  remove: "हटाएं",

  // Support Requests
  supportCenter: "सहायता केंद्र",
  supportCenterDesc:
    "सुविधा अनुरोध या बग रिपोर्ट भेजें। यहाँ फ़ाइलें संलग्न करें और स्थिति ट्रैक करें।",
  requestType: "अनुरोध प्रकार",
  requestTypeFeature: "सुविधा अनुरोध",
  requestTypeBug: "बग रिपोर्ट",
  requestTitle: "शीर्षक",
  requestTitlePlaceholder: "संक्षिप्त सारांश",
  requestDescription: "विवरण",
  requestDescriptionPlaceholder: "चरण, अपेक्षित व्यवहार और संदर्भ।",
  attachments: "संलग्नक",
  submitRequest: "अनुरोध सबमिट करें",
  submitting: "सबमिट किया जा रहा है...",
  requestStatus: "आपके अनुरोध",
  noSupportRequests: "अभी तक कोई अनुरोध सबमिट नहीं किया गया।",
  supportStatusSubmitted: "सबमिट किया गया",
  supportStatusInReview: "समीक्षा में",
  supportStatusPlanned: "नियोजित",
  supportStatusInProgress: "प्रगति में",
  supportStatusResolved: "सुलझाया गया",
  supportStatusRejected: "अस्वीकृत",
  supportFormError: "कृपया शीर्षक और विवरण जोड़ें।",
  supportSubmitFailed: "अनुरोध सबमिट करने में विफल। कृपया पुनः प्रयास करें।",
  supportResponseNote: "आप किसी भी समय और अनुरोध जोड़ सकते हैं।",
  delete: "हटाएं",
  confirmDelete: "क्या आप वाकई इस सहायता अनुरोध को हटाना चाहते हैं?",
  confirm: "पुष्टि करें",
  supportDeleteFailed: "अनुरोध हटाने में विफल। कृपया पुनः प्रयास करें।",

  tourMobileSettingsTitle: "सेटिंग्स और क्रियाएँ",
  tourMobileSettingsDesc: "यहाँ से सत्र सेटिंग्स तक पहुँचें। आप इस मेनू में QR कोड, CSV निर्यात और सत्र समाप्त करें बटन भी पा सकते हैं।",
  sessionActions: "सत्र क्रियाएँ",

  // Landing Page
  heroSubtitle: "AI-संचालित Q&A प्लेटफॉर्म जो दर्शकों के प्रश्नों को तुरंत मॉडरेट, समूहबद्ध और सारांशित करता है।",
  features: "विशेषताएं",
  howItWorks: "यह कैसे काम करता है",
  presenterLogin: "प्रस्तुतकर्ता लॉगिन",
  goToDashboard: "डैशबोर्ड पर जाएं",
  dashboardLabel: "डैशबोर्ड",
  buyMeCoffee: "कॉफी खरीदें",
  newPresentationMode: "नया: इंटरैक्टिव प्रस्तुति मोड",
  superchargedByGemini: "Gemini 3 Pro द्वारा संचालित",
  aiEngineDesc: "हम केवल प्रश्न एकत्रित नहीं करते हैं। हम उन्हें समझते हैं। हमारा AI इंजन विषयों को समूहित करता है, शोर को फ़िल्टर करता है और महत्वपूर्ण को प्राथमिकता देता है।",
  semanticGrouping: "सिमेंटिक ग्रुपिंग",
  semanticGroupingDesc: "यदि दस लोग अलग-अलग तरीकों से पूछते हैं, तो VoxPop मुख्य विषय की पहचान करता है। अपने Q&A को साफ और केंद्रित रखें।",
  slideSyncDesc: "अपनी स्लाइड अपलोड करें। प्रश्न स्वचालित रूप से स्लाइड के अनुसार टैग किए जाते हैं।",
  liveInsights: "लाइव अंतर्दृष्टि",
  liveInsightsDesc: "बोलते समय वास्तविक समय में दर्शकों की भावना और जुड़ाव का स्तर प्राप्त करें।",
  feedbackModeDesc: "रेटिंग और मुख्य निष्कर्ष मांगकर अपना सत्र समाप्त करें।",
  seeDemo: "डेमो देखें",
  effortlessTitle: "सभी के लिए आसान",
  createSession: "सत्र बनाएं",
  createSessionDesc: "मेजबान सेकंडों में चैनल सेटअप कर सकता है।",
  audienceJoinsQR: "QR के माध्यम से जुड़ें",
  audienceJoinsQRDesc: "कोई ऐप डाउनलोड नहीं। कोई लॉगिन नहीं। बस कैमरे से स्कैन करें और पूछें।",
  aiModeratesGroups: "AI मॉडरेट और ग्रुप करता है",
  aiModeratesGroupsDesc: "प्रश्न विषय और महत्व के अनुसार डैशबोर्ड पर व्यवस्थित होते हैं।",
  readyToEngage: "जुड़ने के लिए तैयार?",
  readyToEngageDesc: "उन हजारों प्रस्तुतकर्ताओं में शामिल हों जो VoxPop का उपयोग करते हैं।",
  getStartedFree: "मुफ्त में शुरू करें",
  noCreditCardDesc: "किसी क्रेडिट कार्ड की आवश्यकता नहीं। हमेशा के लिए मुफ्त।",

  sessionPlaceholder: "उदा. Q4 बैठक",
  geminiAnalysis: "Gemini विश्लेषण",
  problemHeading: "लाइव Q&A क्यों टूटा है",
  frictionlessTitle: "घर्षण रहित भागीदारी",
  knowAudienceTitle: "अपने दर्शकों को जानें",
  high: "उच्च",
  featGrammar: "व्याकरण",
  featProfanity: "अश्लीलता फ़िल्टर",
  featTopic: "विषय टैगिंग",
  featGrouping: "स्मार्ट ग्रुपिंग",
  mockPricing: "मूल्य निर्धारण",
  mockAPI: "API",
  mockSecurity: "सुरक्षा",
  footerText: "© 2024 VoxPop AI",
  joinInstruction: "मेजबान द्वारा दिया गया कोड दर्ज करें।",
  tapToAsk: "पूछने के लिए टैप करें!",

  settings: "सेटिंग्स",
  appearance: "दिखावट",
  language: "भाषा",
  theme: "थीम",
  sessionDetails: "सत्र विवरण",
  participation: "भागीदारी",
  participants: "प्रतिभागियों",
  saveChanges: "परिवर्तन सहेजें",
  saving: "सहेजा जा रहा है...",

  aiFeaturesDisabled: "AI सुविधाएँ अक्षम",
  enableAiFeatures: "AI सक्षम करने के लिए सेटिंग्स में API कुंजी जोड़ें।",
  aiWarningTitle: "AI चेतावनी",
  aiTokenPreconditionMessage:
    "AI सुविधाएँ अस्थायी रूप से उपलब्ध नहीं हैं (412)। यदि आप प्रस्तोता हैं, तो सेटिंग्स में अपनी Gemini API कुंजी जांचें, सुनिश्चित करें कि वह सक्रिय है और बिलिंग सक्षम है, फिर पुनः प्रयास करें।",
  aiQuotaExceededMessage:
    "AI कोटा या रेट लिमिट पहुंच गई है। थोड़ी देर बाद पुनः प्रयास करें या अपने Gemini प्लान और बिलिंग की जांच करें।",
  welcome: "स्वागत है",
  setupPrompt: "आइए VoxPop AI सेटअप करें।",
  activateAi: "सक्रिय करें",
  activateAiDesc: "VoxPop Gemini का उपयोग करता है।",
  getStarted: "शुरू करें",
  enterGeminiKey: "Gemini API कुंजी दर्ज करें",
  keyStoredLocally: "आपकी कुंजी स्थानीय रूप से संग्रहीत है।",
  needKeyPrompt: "कुंजी चाहिए? यहाँ प्राप्त करें",
  saveContinue: "सहेजें और जारी रखें",
  viewPresenter: "प्रस्तुतकर्ता",
  viewAudience: "दर्शक",
  loading: "लोड हो रहा है...",
  incorrectPin: "गलत पिन कोड",
  errorValidatingPin: "PIN सत्यापित करने में त्रुटि",
  sessionId: "सत्र आईडी",
  sessionIdPlaceholder: "उदा. A1B2-C3D4…",

  // FeedbackView
  ratePrompt: "आप इस प्रस्तुति को कैसे रेट करेंगे?",
  keyTakeaway: "एक मुख्य निष्कर्ष?",
  submitSeeCheatSheet: "सबमिट करें और चीट शीट देखें →",
  submitFeedbackBtn: "फीडबैक सबमिट करें",
  skipStep: "इस चरण को छोड़ें",
  unlocked: "अनलॉक किया गया",
  generatingAiSummary: "जनरेटिव AI सत्र का सारांश बना रहा है…",
  savedToClipboard: "क्लिपबोर्ड पर सहेजा गया!",
  copySummary: "सारांश कॉपी करें",
  screenshotsEncouraged: "स्क्रीनशॉट प्रोत्साहित हैं! 📸",
  feedbackSubmitted: "आपकी प्रतिक्रिया सफलतापूर्वक सबमिट कर दी गई है।",

  // ParticipantList
  onlineCount: "ऑनलाइन",
  noParticipants: "यहाँ अभी कोई और नहीं है।",
  joinedAt: "शामिल हुआ",

  // QuestionCard
  pinned: "पिन किया गया",
  onHold: "होल्ड पर",
  waitingApproval: "अनुमोदन की प्रतीक्षा है…",
  rejected: "अस्वीकृत",
  questionBlocked: "प्रश्न अवरुद्ध: अनुचित सामग्री का पता चला।",
  editedFrom: "संपादित:",
  ownQuestionVoteError: "आप अपने प्रश्न पर वोट नहीं कर सकते",
  upvoteAria: "प्रश्न को वोट दें, वर्तमान गिनती",
  voteCount: "वोट गिनती",
  markPending: "लंबित के रूप में चिह्नित करें",
  markAnsweredDone: "उत्तर दिया गया के रूप में चिह्नित करें",
  markDone: "पूर्ण",
  markDoneShort: "पूर्ण चिह्नित करें",
  removeFromFavorites: "पसंदीदा से हटाएँ",
  addToFavorites: "पसंदीदा में जोड़ें",
  unpinQuestion: "प्रश्न अनपिन करें",
  pinQuestion: "प्रश्न पिन करें",

  // PresenterDashboard & LandingPage
  slideNum: "स्लाइड",
  supportsFiles: "छवियाँ (JPG, PNG) और PDF समर्थित",
  addBtn: "जोड़ें",
  slideProcessing: "प्रोसेस हो रहा है",
  deleteSlide: "स्लाइड हटाएं",
  deleteSlideConfirm: "यह स्लाइड हटाएं? इसे वापस नहीं किया जा सकता।",
  liveIndicator: "लाइव",
  aiReady: "AI तैयार",
  newCount: "नया",
  unrelatedQuestions: "विशिष्ट स्लाइड से असंबंधित",
  generalQuestionsDesc: "प्रश्न जिन्हें AI विशिष्ट स्लाइड से लिंक नहीं कर सका।",
  archivedStatus: "संग्रहीत",
  all: "साभी",
  signOut: "साइन आउट",
  signInRequired: "अनुरोध सबमिट करने के लिए कृपया साइन इन करें।",
  newSession: "नया सत्र",
  joinExisting: "मौजूदा में शामिल हों",
  lightTheme: "लाइट",
  darkTheme: "डार्क मोड",
  systemTheme: "सिस्टम डिफॉल्ट",
  auroraEffect: "ध्रुवीय प्रभाव (Aurora)",
  auroraEffectDesc: "गतिशील पृष्ठभूमि एनिमेशन",
  pinCodeLabel: "पिन कोड",
  changesSaved: "परिवर्तन सफलतापूर्वक सहेजे गए!",
  votesLabel: "वोट",
  pressEnter: "Enter दबाएं",
  enterKey: "Enter",
  copied: "कॉपी किया गया!",
  copyJoinLink: "जुड़ने का लिंक कॉपी करें",
  confirmAccessControlChange: "एक्सेस कंट्रोल सक्षम करने से वर्तमान प्रतिभागी डिस्कनेक्ट हो सकते हैं। क्या आप वाकई जारी रखना चाहते हैं?",
  idShort: "ID:",
  enterPinPlaceholder: "6-अंकीय पिन दर्ज करें...",
  smartSuggestion: "स्मार्ट सुझाव",
  smartSuggestionDesc: "अपने दर्शकों को बेहतर प्रश्न पूछने में मदद करें। हमारा AI सुझाव देता है।",
  aiAnalysisPrefix: "AI विश्लेषण:",
  analyzingSlides: "AI के साथ स्लाइड का विश्लेषण कर रहा है...",
  analyzedSlideProgress: "विश्लेषित स्लाइड",
  processingFiles: "फ़ाइलों को संसाधित कर रहा है...",
  pdfProcessError: "PDF को संसाधित नहीं किया जा सका:",
  uploadingProgress: "अपलोड हो रहा है",
  noQuestionsSlide: "इस स्लाइड पर अभी तक कोई प्रश्न नहीं पूछा गया है।",
  fileTooLarge: "फ़ाइल का आकार बहुत बड़ा है।",
  maxSize: "(अधिकतम {0}MB)",
  unsupportedFiles: "कुछ फ़ाइलें समर्थित नहीं हैं। अनुमति दी गई: {0}",
  filesSelected: "{0} फ़ाइलें चयनित",
  statusLive: "लाइव",
  limitLabel: "सीमा",
  anonymous: "अनाम",
  questionLimitReached: "आप इस सत्र के लिए अपनी प्रश्न सीमा तक पहुँच गए हैं।",
  submitError: "प्रश्न सबमिट करने में विफल। कृपया अपना कनेक्शन जांचें।",
  sessionIsLocked: "सत्र लॉक है",
  sessionLockedAlert: "सत्र लॉक है। नए प्रश्नों की अनुमति नहीं है।",
  editProfile: "प्रोफ़ाइल संपादित करें",
  activeSessionDetected: "सक्रिय सत्र का पता चला",
  archivePrompt: "आपके पास एक लाइव सत्र है। नया शुरू करने के लिए इसे आर्काइव किया जाना चाहिए।",
  returnToLiveSessionPrompt: "आपके पास एक लाइव सत्र प्रगति पर है।",
  archiveAndCreate: "आर्काइव और बनाएँ",
  archiveAndCreateNew: "आर्काइव और नया बनाएँ",
  returnToSession: "लाइव सत्र पर वापस लौटें",
  or: "या",
  toggleParticipantList: "सक्रिय प्रतिभागी सूची टॉगल करें",
  rateStarAria: "5 में से {0} स्टार",
  copyToClipboardAria: "सारांश को क्लिपबोर्ड पर कॉपी करें",

  // User Dashboard
  myDashboard: "मेरा डैशबोर्ड",
  profile: "प्रोफ़ाइल",
  sessionHistory: "सत्र इतिहास",
  updateProfile: "प्रोफ़ाइल अपडेट करें",
  displayName: "प्रदर्शन नाम",
  photoUrl: "फोटो यूआरएल",
  saveProfile: "प्रोफ़ाइल सहेजें",
  profileUpdated: "प्रोफ़ाइल सफलतापूर्वक अपडेट की गई",
  noSessions: "कोई सत्र नहीं मिला",
  createFirstSession: "शुरू करने के लिए अपना पहला सत्र बनाएं!",
  viewSession: "सत्र देखें",
  sessions: "सत्र",
  joined: "शामिल हुए",
  created: "बनाया गया",

  // New Dashboard Keys
  welcomeBack: "वापसी पर स्वागत है",
  totalSessions: "सत्र",
  activeSessions: "सक्रिय सत्र",
  yourSessions: "आपके सत्र",
  manageSessionsSubtitle:
    "अपने दर्शक फ़ीडबैक चैनलों को प्रबंधित और मॉनिटर करें",
  readyToStart: "शुरू करने के लिए तैयार?",
  creating: "बना रहा है",
  logout: "लॉग आउट",
  errorArchiving: "सत्र संग्रह त्रुटि",
  errorUploadingSlide: "स्लाइड अपलोड त्रुटि। सत्र इसके बिना बनाया गया।",
  geminiApiKey: "जेमिनी एपीआई कुंजी",
  geminiApiKeyPlaceholder: "अपनी जेमिनी एपीआई कुंजी दर्ज करें",
  geminiPrivacyNote: "आपकी कुंजी स्थानीय रूप से आपके ब्राउज़र में संग्रहीत होती है और हमारे सर्वर पर कभी नहीं भेजी जाती है।",
  aiStatusActive: "AI सक्रिय",
  aiStatusInactive: "AI निष्क्रिय",
  aiActiveBenefit: "स्मार्ट ग्रुपिंग और सारांश तैयार हैं।",
  aiInactiveAction: "AI शक्तियों को अनलॉक करने के लिए कुंजी जोड़ें",
  getKeyLink: "मुफ्त जेमिनी API कुंजी प्राप्त करें",
  sessionNoAiPower: "नोट: आपका सत्र AI के बिना चलेगा क्योंकि API सक्रिय नहीं है।",
  backToDashboard: "डैशबोर्ड पर वापस जाएं",
  manageYourSettings: "अपनी वैश्विक प्राथमिकताओं और AI कॉन्फ़िगरेशन को प्रबंधित करें",
  appPreferences: "ऐप प्राथमिकताएं",
  aiConfigurationMoved: "AI कॉन्फ़िगरेशन स्थानांतरित",
  aiConfigurationMovedDesc: "जेमिनी AI सेटिंग्स अब वैश्विक हैं। आप एक ही स्थान पर सभी सत्रों के लिए अपनी API कुंजी प्रबंधित कर सकते हैं।",
  goToUserSettings: "उपयोगकर्ता सेटिंग्स पर जाएं",
  manageAiKeysInSettings: "वैश्विक सेटिंग्स में अपनी जेमिनी API कुंजी प्रबंधित करें",
  goToSettings: "सेटिंग्स पर जाएं",
  aiConfiguration: "AI कॉन्फ़िगरेशन",
  sessionEndedReadOnly: "सत्र समाप्त (केवल पढ़ने के लिए)",
  maxSessionsReached: "आप सत्रों की अधिकतम सीमा तक पहुँच गए हैं। कृपया नया बनाने के लिए पुराने को संग्रहित या हटाएँ।",

  // Tour
  tourViewSwitcherTitle: "व्यू स्विचर",
  tourViewSwitcherDesc: "प्रस्तुतकर्ता व्यू (डैशबोर्ड) और दर्शक व्यू (जो उपयोगकर्ता देखते हैं) के बीच टॉगल करें।",
  tourLiveFeedTitle: "लाइव फीड",
  tourLiveFeedDesc: "वास्तविक समय में दर्शकों के आने वाले प्रश्नों की निगरानी करें। उन्हें पसंदीदा बनाएं, पिन करें, या उत्तर दिया गया चिह्नित करें।",
  tourSlideSyncTitle: "स्लाइड सिंक",
  tourSlideSyncDesc: "आने वाले प्रश्नों को स्लाइड द्वारा स्वचालित रूप से समूहबद्ध करने के लिए अपनी प्रस्तुति स्लाइड अपलोड करें।",
  tourAiInsightsTitle: "AI अंतर्दृष्टि",
  tourAiInsightsDesc: "तुरंत सारांश उत्पन्न करने, भावनाओं का विश्लेषण करने और ट्रेंडिंग विषयों का पता लगाने के लिए Gemini 3 Pro का उपयोग करें।",
  tourFeedbackLoopTitle: "फीडबैक लूप",
  tourFeedbackLoopDesc: "अपना सत्र समाप्त करते समय, बंद करने से पहले दर्शकों की रेटिंग और मुख्य निष्कर्ष एकत्र करने के लिए इस टैब पर स्विच करें।",
  tourSettingsTitle: "सेटिंग्स और API कुंजी",
  tourSettingsDesc: "अपने सत्र विकल्पों को कॉन्फ़िगर करें और AI सुविधाओं को सक्षम करने के लिए यहां अपनी Gemini API कुंजी दर्ज करें।",
  tourJoinCodeTitle: "जुड़ने का कोड",
  tourJoinCodeDesc: "अपने दर्शकों के शामिल होने के लिए QR कोड और सत्र ID दिखाने के लिए यहां क्लिक करें।",

  // CSV Export
  author: "लेखक",
  text: "पाठ",
  topic: "विषय",
  upvotes: "अपवोट",
  status: "स्थिति",
  timestamp: "समय",
};

const vi = {
  appTitle: "VoxPop AI",
  appDesc: "Tương tác khán giả thời gian thực",
  startSession: "Bắt đầu phiên Q&A",
  joinSession: "Tham gia",
  orJoin: "hoặc tham gia phiên có sẵn",
  setupSession: "Thiết lập phiên",
  configureChannel: "Cấu hình kênh Q&A của bạn",
  sessionTitle: "Tiêu đề phiên",
  descOptional: "Mô tả (Tùy chọn)",
  maxQuestions: "Tối đa câu hỏi/người",
  accessControl: "Kiểm soát truy cập",
  protected: "Được bảo vệ",
  public: "Công khai",
  optional: "Tùy chọn",
  requiresPin: "Yêu cầu PIN",
  requireLogin: "Yêu cầu đăng nhập Google",
  requireLoginDesc: "Người tham gia phải đăng nhập Google trước khi vào.",
  freeToJoin: "Tham gia miễn phí",
  addDescriptionPrompt: "Thêm mô tả để giúp AI hiểu bối cảnh...",
  uploadSlidePrompt: "Tải lên bài thuyết trình để hướng dẫn khán giả...",
  uploadSlideBtn: "Tải lên bài thuyết trình",
  optionalEncouragement: "Tùy chọn, nhưng được khuyến nghị để có kết quả AI tốt hơn.",
  cancel: "Hủy",
  close: "Đóng",
  createChannel: "Tạo kênh",
  joinTitle: "Chào mừng!",
  joining: "Bạn đang tham gia",
  yourName: "Tên của bạn",
  leaveBlank: "Để trống để sử dụng",
  joinBtn: "Tham gia phiên",
  loginRequiredTitle: "Đăng nhập để tham gia",
  loginRequiredDesc: "Phiên này yêu cầu đăng nhập Google trước khi tham gia.",
  continueWithGoogle: "Tiếp tục với Google",
  signedInAs: "Đã đăng nhập là",
  recent: "Gần đây",
  popular: "Phổ biến",
  mine: "Của tôi",
  noQuestions: "Chưa có câu hỏi nào",
  typeQuestion: "Nhập câu hỏi...",
  askingDisabled: "Việc đặt câu hỏi đã bị tắt",
  postAs: "Đăng dưới tên",
  left: "còn lại",
  liveFeed: "Trực tiếp",
  analytics: "Phân tích",
  insights: "Thông tin AI",
  exportCSV: "Xuất CSV",
  endSession: "Kết thúc",
  sessionEnded: "Phiên đã kết thúc",
  joinCode: "Mã tham gia",
  showQR: "Hiện QR",
  trendingTopics: "Chủ đề xu hướng",
  engagement: "Tương tác",
  active: "Hoạt động",
  passive: "Thụ động",
  aiAnalysisReady: "Phân tích AI sẵn sàng",
  generateInsights: "Tạo thông tin chi tiết",
  addApiKey: "Thêm Key API để bật AI",
  removeApiKeyTitle: "Xóa khóa API?",
  removeApiKeyConfirm: "Tính năng AI sẽ ngừng hoạt động cho đến khi lưu khóa mới.",
  removeApiKeyAction: "Xóa khóa",
  refreshAnalysis: "Làm mới phân tích",
  online: "Trực tuyến",
  activeParticipants: "Người tham gia hoạt động",
  markAnswered: "Đã trả lời",
  answered: "Đã trả lời",
  hide: "Ẩn",
  unhide: "Bỏ ẩn",
  favorite: "Yêu thích",
  pin: "Ghim lên đầu",
  analyzing: "Đang phân tích...",
  autoGroup: "Tự động nhóm",
  checkGrammar: "Kiểm tra ngữ pháp",
  reanalyze: "Phân tích lại",
  checking: "Đang kiểm tra...",
  aiSuggestion: "Gợi ý AI",
  applyChange: "Áp dụng",
  dismiss: "Bỏ qua",
  questions: "Câu hỏi",
  endSessionConfirmTitle: "Kết thúc phiên?",
  endSessionConfirmBody:
    "Hành động này sẽ đóng phiên vĩnh viễn. Người tham gia sẽ bị ngắt kết nối.",
  confirmEnd: "Có, kết thúc",
  sessionUnavailable: "Phiên không khả dụng",
  createError: "Không thể tạo phiên. Vui lòng thử lại.",
  error: "Lỗi",
  sessionEndedMessage: "Phiên Q&A này đã kết thúc.",
  backToHome: "Về trang chủ",
  aiPriorityEx: "Điểm số dựa trên ngữ pháp và mức độ liên quan.",
  presentationMode: "Chế độ trình bày",
  startPresentation: "Bắt đầu trình bày",
  presenting: "Đang trình bày",
  noQuestionsFilter: "Không có câu hỏi nào",
  exitPresentation: "Thoát trình bày",
  next: "Tiếp",
  prev: "Trước",
  shortcuts: "Phím tắt",
  markAnsweredShort: "Đã trả lời",
  keyboardHint: "Dùng ← → để điều hướng, Enter để trả lời",

  slides: "Slide",
  uploadSlides: "Tải lên Slide",
  uploadSlidesDesc:
    "Tải lên bài thuyết trình (hình ảnh) để nhóm câu hỏi theo slide.",
  uploadBtn: "Chọn Hình ảnh",
  processingSlides: "Đang xử lý slide...",
  generalQuestions: "Chung / Khác",
  currentSlide: "Slide hiện tại",
  setAsCurrent: "Đặt làm hiện tại",
  questionsForSlide: "Câu hỏi cho Slide",

  softCloseTitle: "Tổng kết phiên?",
  softCloseBody:
    "Bạn có thể vào 'Chế độ phản hồi' để dừng câu hỏi mới và xin đánh giá.",
  startFeedback: "Bắt đầu chế độ phản hồi",
  endImmediately: "Kết thúc ngay",
  feedbackMode: "Chế độ phản hồi",
  feedbackLive: "Phản hồi đang diễn ra",
  feedbackLocked: "Phản hồi đã bị khóa",
  feedbackLockedDesc:
    "Bắt đầu chế độ phản hồi để cho phép khán giả đánh giá phiên họp và mở khóa Cheat Sheet.",
  startFeedbackMode: "Bắt đầu chế độ phản hồi",
  finalResults: "Kết quả cuối cùng",
  responded: "Đã phản hồi",
  participantsLabel: "người tham gia",
  liveComments: "Bình luận trực tiếp",
  waitingForComments: "Đang chờ bình luận...",
  noComment: "Không có bình luận nào",
  waitingForFeedback: "Đang chờ phản hồi...",
  analyzeSentiment: "Phân tích cảm xúc",
  reanalyzeSentiment: "Phân tích lại cảm xúc",
  averageRating: "Đánh giá trung bình",
  netScore: "Điểm phiên",
  archiveSession: "Lưu trữ & Đóng",
  rateSession: "Đánh giá phiên này",
  feedbackPlaceholder: "Bài học chính của bạn là gì? (Tùy chọn)",
  submitFeedback: "Gửi phản hồi",
  thankYou: "Cảm ơn!",
  aiTakeawayTitle: "Tóm tắt phiên AI của bạn",
  aiTakeawayDesc: "VoxPop đã phân tích và tạo bản tóm tắt này cho bạn.",
  generatingTakeaway: "Đang tạo tóm tắt...",
  generateTakeawayDesc: "Tạo bản tóm tắt ngắn gọn về slide và Q&A cho khán giả của bạn.",
  generateBtn: "Tạo",
  updating: "Đang cập nhật...",
  copy: "Sao chép",
  feedbackReport: "Báo cáo phản hồi",
  exitSession: "Thoát phiên",
  remove: "Xóa",

  // Support Requests
  supportCenter: "Trung tâm Hỗ trợ",
  supportCenterDesc: "Gửi yêu cầu tính năng hoặc báo cáo lỗi. Đính kèm tệp và theo dõi trạng thái tại đây.",
  requestType: "Loại yêu cầu",
  requestTypeFeature: "Yêu cầu tính năng",
  requestTypeBug: "Báo cáo lỗi",
  requestTitle: "Tiêu đề",
  requestTitlePlaceholder: "Tóm tắt ngắn gọn",
  requestDescription: "Chi tiết",
  requestDescriptionPlaceholder: "Các bước, hành vi mong đợi và bối cảnh.",
  attachments: "Tệp đính kèm",
  submitRequest: "Gửi yêu cầu",
  submitting: "Đang gửi...",
  requestStatus: "Yêu cầu của bạn",
  noSupportRequests: "Chưa có yêu cầu nào được gửi.",
  supportStatusSubmitted: "Đã gửi",
  supportStatusInReview: "Đang xem xét",
  supportStatusPlanned: "Đã lập kế hoạch",
  supportStatusInProgress: "Đang xử lý",
  supportStatusResolved: "Đã giải quyết",
  supportStatusRejected: "Đã từ chối",
  supportFormError: "Vui lòng thêm tiêu đề và mô tả.",
  supportSubmitFailed: "Gửi yêu cầu thất bại. Vui lòng thử lại.",
  supportResponseNote: "Bạn có thể thêm yêu cầu mới bất cứ lúc nào.",

  tourMobileSettingsTitle: "Cài đặt & Hành động",
  tourMobileSettingsDesc: "Truy cập cài đặt phiên từ đây. Bạn cũng có thể tìm thấy các nút Mã QR, Xuất CSV và Kết thúc phiên trong menu này.",
  sessionActions: "Hành động phiên",

  // Landing Page
  heroTitle:
    "Biến sự im lặng của khán giả thành thông tin chi tiết thời gian thực.",
  heroSubtitle:
    "Nền tảng Q&A được hỗ trợ bởi AI giúp điều phối, nhóm và tóm tắt các câu hỏi của khán giả ngay lập tức. Không cần đăng nhập.",
  features: "Tính năng",
  howItWorks: "Cách thức hoạt động",
  presenterLogin: "Đăng nhập Diễn giả",
  goToDashboard: "Đi đến Bảng điều khiển",
  dashboardLabel: "Bảng điều khiển",
  newPresentationMode: "Mới: Chế độ Thuyết trình Tương tác",
  superchargedByGemini: "Được hỗ trợ bởi Gemini 3 Pro",
  aiEngineDesc:
    "Chúng tôi không chỉ thu thập câu hỏi. Chúng tôi hiểu chúng. Công cụ AI của chúng tôi nhóm các chủ đề, lọc nhiễu và ưu tiên những gì quan trọng.",
  semanticGrouping: "Nhóm theo ngữ nghĩa",
  semanticGroupingDesc:
    'Mười người hỏi về "Làm việc từ xa" theo những cách khác nhau? VoxPop nhận thấy đó là một chủ đề chính. Giữ cho buổi Q&A của bạn sạch sẽ và tập trung.',
  slideSyncDesc:
    "Tải lên các slide của bạn. Các câu hỏi được tự động gắn thẻ vào slide trên màn hình.",
  liveInsights: "Thông tin chi tiết Trực tiếp",
  liveInsightsDesc:
    "Nắm bắt tâm lý và mức độ tương tác của khán giả trong thời gian thực khi bạn nói.",
  feedbackModeDesc:
    "Kết thúc phiên bằng cách yêu cầu đánh giá và các điểm rút ra chính. VoxPop tạo bản tóm tắt văn bản để mọi người lưu giữ.",
  seeDemo: "Xem Demo",
  effortlessTitle: "Nỗ lực tối thiểu cho mọi người",
  createSession: "Tạo một Phiên",
  createSessionDesc:
    "Người tổ chức thiết lập kênh trong vài giây. Không cần cấu hình phức tạp.",
  audienceJoinsQR: "Khán giả tham gia qua QR",
  audienceJoinsQRDesc:
    "Không cần tải ứng dụng. Không cần đăng nhập. Chỉ cần hướng camera và bắt đầu hỏi.",
  aiModeratesGroups: "AI Điều phối & Nhóm",
  aiModeratesGroupsDesc:
    "Các câu hỏi xuất hiện trên bảng điều khiển của người tổ chức, được sắp xếp theo chủ đề và tầm quan trọng.",
  readyToEngage: "Sẵn sàng tương tác?",
  readyToEngageDesc:
    "Tham gia cùng hàng ngàn diễn giả sử dụng VoxPop để làm cho các phiên của họ không thể nào quên.",
  getStartedFree: "Bắt đầu miễn phí",
  noCreditCardDesc: "Không yêu cầu thẻ tín dụng. Gói miễn phí mãi mãi.",

  sessionPlaceholder: "ví dụ: Họp Q4",
  geminiAnalysis: "Phân tích Gemini",
  problemHeading: "Tại sao Q&A trực tiếp lại khó",
  frictionlessTitle: "Tham gia không rào cản",
  knowAudienceTitle: "Hiểu khán giả của bạn",
  high: "Cao",
  featGrammar: "Sửa ngữ pháp",
  featProfanity: "Lọc từ xấu",
  featTopic: "Gắn thẻ chủ đề",
  featGrouping: "Nhóm thông minh",
  mockPricing: "Giá cả",
  mockAPI: "API",
  mockSecurity: "Bảo mật",
  footerText: "© 2024 VoxPop AI. Hỗ trợ bởi Gemini 3 Pro.",
  joinInstruction: "Nhập mã 8 ký tự từ người tổ chức.",
  tapToAsk: "Chạm bên dưới để hỏi!",

  settings: "Cài đặt",
  appearance: "Giao diện",
  language: "Ngôn ngữ",
  theme: "Chủ đề",
  sessionDetails: "Chi tiết phiên",
  participation: "Tham gia",
  participants: "Người tham gia",
  saveChanges: "Lưu thay đổi",
  saving: "Đang lưu...",

  aiFeaturesDisabled: "Tính năng AI đã tắt",
  enableAiFeatures:
    "Vui lòng thêm khóa API Gemini trong Cài đặt để bật tính năng AI.",
  aiWarningTitle: "Cảnh báo AI",
  aiTokenPreconditionMessage:
    "Tính năng AI tạm thời không khả dụng (412). Nếu bạn là người trình bày, hãy kiểm tra khóa API Gemini trong Cài đặt, đảm bảo khóa hoạt động và đã bật thanh toán, rồi thử lại.",
  aiQuotaExceededMessage:
    "Đã đạt giới hạn quota hoặc tốc độ của AI. Vui lòng chờ một chút rồi thử lại hoặc kiểm tra gói và thanh toán Gemini.",
  welcome: "Chào mừng",
  setupPrompt: "Hãy thiết lập VoxPop AI. Cần có khóa API để AI hoạt động.",
  activateAi: "Kích hoạt",
  activateAiDesc: "VoxPop sử dụng Google Gemini để tạo tóm tắt và phân tích.",
  getStarted: "Bắt đầu",
  enterGeminiKey: "Nhập khóa API Gemini",
  keyStoredLocally: "Khóa của bạn được lưu cục bộ và mã hóa.",
  needKeyPrompt: "Cần khóa? Nhận miễn phí tại",
  saveContinue: "Lưu & Tiếp tục",
  viewPresenter: "Diễn giả",
  viewAudience: "Khán giả",
  loading: "Đang tải...",
  incorrectPin: "Mã PIN sai",
  errorValidatingPin: "Lỗi xác thực mã PIN",
  sessionId: "ID Phiên",
  sessionIdPlaceholder: "ví dụ A1B2-C3D4…",
  copyJoinLink: "Sao chép liên kết tham gia",
  analyticsInsights: "Phân tích & Thông tin chi tiết",
  popularTopics: "Chủ đề phổ biến",
  aiConsultant: "Cố vấn AI",
  aiConsultantDesc:
    "Phân tích câu hỏi để tìm ra quy luật và tóm tắt phiên họp.",
  runAnalysis: "Chạy phân tích",
  regenerateSummary: "Tạo lại tóm tắt",
  addApiKeyFirst: "Thêm khóa API trước",
  advancedInsightsComingSoon: "Thông tin chi tiết nâng cao sắp ra mắt",
  advancedInsightsDesc:
    "Phân tích AI sâu hơn về cảm ước và xu hướng tương tác.",
  endSessionDesc:
    "Kết thúc phiên họp cho phép bạn thu thập phản hồi. Khán giả sẽ không thể đặt câu hỏi mới.",

  // FeedbackView
  ratePrompt: "Bạn đánh giá bài thuyết trình này thế nào?",
  keyTakeaway: "Một bài học chính?",
  submitSeeCheatSheet: "Gửi & Xem Tóm tắt →",
  submitFeedbackBtn: "Gửi phản hồi",
  skipStep: "Bỏ qua bước này",
  unlocked: "ĐÃ MỞ KHÓA",
  sessionLockedAlert: "Phiên họp đã bị khóa. Không thể đặt câu hỏi mới.",
  questionLimitReached: "Bạn đã đạt đến giới hạn câu hỏi cho phiên họp này.",
  submitError: "Gửi câu hỏi thất bại. Vui lòng kiểm tra kết nối của bạn.",
  sessionIsLocked: "Phiên họp đã bị khóa",
  generatingAiSummary: "AI đang tổng hợp phiên…",
  savedToClipboard: "Đã lưu vào bộ nhớ tạm!",
  copySummary: "Sao chép tóm tắt",
  screenshotsEncouraged: "Khuyến khích chụp màn hình! 📸",
  feedbackSubmitted: "Phản hồi của bạn đã được gửi thành công.",

  // ParticipantList
  onlineCount: "Trực tuyến",
  anonymous: "Ẩn danh",
  noParticipants: "Chưa có ai khác ở đây.",
  joinedAt: "Đã tham gia",

  // QuestionCard
  pinned: "Đã ghim",
  onHold: "Đang chờ",
  waitingApproval: "Đang chờ duyệt…",
  rejected: "Đã từ chối",
  questionBlocked: "Câu hỏi bị chặn: phát hiện nội dung không phù hợp.",
  editedFrom: "Đã sửa từ:",
  ownQuestionVoteError: "Bạn không thể bình chọn cho câu hỏi của chính mình",
  upvoteAria: "Bình chọn câu hỏi, số lượng hiện tại",
  voteCount: "Số phiếu",
  markPending: "Đánh dấu là đang chờ",
  markAnsweredDone: "Đánh dấu là đã trả lời",
  markDone: "Xong",
  markDoneShort: "Đánh dấu Xong",
  removeFromFavorites: "Xóa khỏi yêu thích",
  addToFavorites: "Thêm vào yêu thích",
  unpinQuestion: "Bỏ ghim câu hỏi",
  pinQuestion: "Ghim câu hỏi",

  // PresenterDashboard & LandingPage
  slideNum: "Slide",
  supportsFiles: "Hỗ trợ Ảnh (JPG, PNG) và PDF",
  addBtn: "Thêm",
  slideProcessing: "Đang xử lý",
  deleteSlide: "Xóa slide",
  deleteSlideConfirm: "Xóa slide này? Không thể hoàn tác.",
  liveIndicator: "TRỰC TIẾP",
  aiReady: "AI Sẵn sàng",
  newCount: "mới",
  unrelatedQuestions: "Không liên quan đến slide cụ thể",
  generalQuestionsDesc:
    "Câu hỏi mà AI không thể liên kết với một slide cụ thể.",
  archivedStatus: "Đã lưu trữ",
  all: "Tất cả",
  signOut: "Đăng xuất",
  signInRequired: "Vui lòng đăng nhập để gửi yêu cầu.",
  newSession: "Phiên mới",
  joinExisting: "Tham gia có sẵn",
  lightTheme: "Sáng",
  darkTheme: "Chế độ tối",
  auroraEffect: "Hiệu ứng Cực quang",
  statusLive: "Trực tiếp",
  limitLabel: "Giới hạn",
  pinCodeLabel: "Mã PIN",
  changesSaved: "Thay đổi đã được lưu thành công!",
  votesLabel: "Phiếu",
  pressEnter: "Nhấn Enter",
  enterKey: "Enter",
  confirm: "Xác nhận",
  delete: "Xóa",
  confirmDelete: "Bạn có chắc chắn muốn xóa yêu cầu hỗ trợ này không?",
  supportDeleteFailed: "Không thể xóa yêu cầu. Vui lòng thử lại.",
  copied: "Đã sao chép!",
  idShort: "ID:",
  enterPinPlaceholder: "Nhập mã PIN 6 chữ số...",
  confirmAccessControlChange: "Bật kiểm soát truy cập có thể làm ngắt kết nối các người tham gia hiện tại. Bạn có chắc chắn muốn tiếp tục?",
  smartSuggestion: "Gợi ý thông minh",
  smartSuggestionDesc: "Giúp khán giả đặt câu hỏi tốt hơn. AI của chúng tôi sẽ đưa ra gợi ý dựa trên nguyên lý Kim Tự Tháp.",
  aiAnalysisPrefix: "Phân tích AI:",
  analyzingSlides: "Đang phân tích slide bằng AI...",
  analyzedSlideProgress: "Đã phân tích slide",
  processingFiles: "Đang xử lý tệp...",
  pdfProcessError: "Không thể xử lý tệp PDF:",
  uploadingProgress: "Đang tải lên",
  noQuestionsSlide: "Chưa có câu hỏi nào cho slide này.",
  fileTooLarge: "Tệp quá lớn.",
  maxSize: "(Tối đa {0}MB)",
  unsupportedFiles: "Một số tệp không được hỗ trợ. Cho phép: {0}",
  filesSelected: "Đã chọn {0} tệp",
  editProfile: "Chỉnh sửa hồ sơ",
  systemTheme: "Hệ thống",
  auroraEffectDesc: "Hiệu ứng nền động",
  buyMeCoffee: "Mời tôi ly cà phê",
  aiStatusActive: "AI đang hoạt động",
  aiStatusInactive: "AI không hoạt động",
  aiActiveBenefit: "Đã sẵn sàng tạo nhóm thông minh & tóm tắt.",
  aiInactiveAction: "Thêm khóa để mở khóa sức mạnh AI",
  getKeyLink: "Lấy khóa Gemini API miễn phí",
  sessionNoAiPower: "Lưu ý: Phiên của bạn sẽ không có sức mạnh AI vì API chưa được kích hoạt.",
  maxSessionsReached: "Bạn đã đạt giới hạn số lượng phiên. Vui lòng lưu trữ hoặc xóa bớt phiên cũ.",
  skipFeedback: "Bỏ qua phản hồi & Kết thúc",
  toggleParticipantList: "Bật/tắt danh sách người tham gia",
  rateStarAria: "Đánh giá {0} trên 5 sao",
  copyToClipboardAria: "Sao chép tóm tắt vào bộ nhớ tạm",

  // User Dashboard
  myDashboard: "Bảng điều khiển của tôi",
  profile: "Hồ sơ",
  sessionHistory: "Lịch sử phiên",
  updateProfile: "Cập nhật hồ sơ",
  displayName: "Tên hiển thị",
  photoUrl: "Ảnh hồ sơ (URL)",
  saveProfile: "Lưu hồ sơ",
  profileUpdated: "Cập nhật hồ sơ thành công",
  noSessions: "Không tìm thấy phiên nào",
  createFirstSession: "Hãy tạo phiên đầu tiên của bạn để bắt đầu!",
  viewSession: "Xem phiên",
  sessions: "Phiên",
  joined: "Đã tham gia",
  created: "Đã tạo",

  // New Dashboard Keys
  welcomeBack: "Chào mừng trở lại",
  totalSessions: "Số phiên",
  activeSessions: "Phiên hoạt động",
  yourSessions: "Phiên của bạn",
  manageSessionsSubtitle: "Quản lý và giám sát các kênh phản hồi khán giả",
  readyToStart: "Sẵn sàng bắt đầu chưa?",
  creating: "Đang tạo",
  logout: "Đăng xuất",
  activeSessionDetected: "Phát hiện phiên họp đang hoạt động",
  archivePrompt:
    "Bạn hiện có một phiên họp trực tiếp. Bạn phải lưu trữ nó trước khi bắt đầu phiên mới.",
  returnToLiveSessionPrompt: "Bạn đang có một phiên trực tiếp.",
  archiveAndCreate: "Lưu trữ & Tạo mới",
  archiveAndCreateNew: "Lưu trữ & Tạo Phiên Mới",
  returnToSession: "Quay lại Phiên",
  or: "HOẶC",
  errorArchiving: "Lỗi lưu trữ phiên",
  errorUploadingSlide: "Lỗi tải lên slide. Phiên đã tạo không có nó.",
  geminiApiKey: "Khóa API Gemini",
  geminiApiKeyPlaceholder: "Nhập khóa API Gemini của bạn",
  geminiPrivacyNote: "Khóa của bạn được lưu cục bộ trong trình duyệt và không bao giờ được gửi đến máy chủ của chúng tôi.",
  backToDashboard: "Quay lại Bảng điều khiển",
  manageYourSettings: "Quản lý tùy chọn cá nhân và cấu hình AI toàn cục",
  appPreferences: "Tùy chọn ứng dụng",
  aiConfigurationMoved: "Cấu hình AI đã thay đổi vị trí",
  aiConfigurationMovedDesc: "Cài đặt Gemini AI hiện là toàn cục. Bạn có thể quản lý khóa API cho tất cả các phiên ở một nơi duy nhất.",
  goToUserSettings: "Đi đến Cài đặt người dùng",
  manageAiKeysInSettings: "Quản lý khóa API Gemini trong cài đặt toàn cục",
  goToSettings: "Đi đến Cài đặt",
  aiConfiguration: "Cấu hình AI",
  sessionEndedReadOnly: "Phiên đã kết thúc (Chỉ xem)",

  // Tour
  tourViewSwitcherTitle: "Bộ chuyển đổi Chế độ xem",
  tourViewSwitcherDesc: "Chuyển đổi giữa Chế độ xem người thuyết trình (bảng điều khiển) và Chế độ xem khán giả (những gì người dùng thấy).",
  tourLiveFeedTitle: "Nguồn cấp dữ liệu trực tiếp",
  tourLiveFeedDesc: "Theo dõi các câu hỏi đến từ khán giả trong thời gian thực. Yêu thích, ghim hoặc đánh dấu chúng là đã trả lời.",
  tourSlideSyncTitle: "Đồng bộ hóa Slide",
  tourSlideSyncDesc: "Tải lên các slide thuyết trình của bạn để tự động nhóm các câu hỏi đến theo slide.",
  tourAiInsightsTitle: "AI Insights",
  tourAiInsightsDesc: "Sử dụng Gemini 3 Pro để tạo tóm tắt, phân tích cảm xúc và phát hiện các chủ đề xu hướng ngay lập tức.",
  tourFeedbackLoopTitle: "Vòng phản hồi",
  tourFeedbackLoopDesc: "Khi kết thúc phiên của bạn, hãy chuyển sang tab này để thu thập đánh giá của khán giả và các bài học chính trước khi đóng.",
  tourSettingsTitle: "Cài đặt & Khóa API",
  tourSettingsDesc: "Cấu hình các tùy chọn phiên của bạn và nhập Khóa API Gemini tại đây để bật các tính năng AI.",
  tourJoinCodeTitle: "Mã tham gia",
  tourJoinCodeDesc: "Nhấp vào đây để hiển thị mã QR và ID phiên để khán giả của bạn tham gia.",

  // CSV Export
  author: "Tác giả",
  text: "Văn bản",
  topic: "Chủ đề",
  upvotes: "Bình chọn",
  status: "Trạng thái",
  timestamp: "Dấu thời gian",
};

const ar = {
  appTitle: "VoxPop AI",
  appDesc: "تفاعل الجمهور في الوقت الحقيقي",
  startSession: "بدء جلسة س و ج",
  joinSession: "انضم عبر المعرف",
  orJoin: "أو انضم إلى موجودة",
  setupSession: "إعداد الجلسة",
  configureChannel: "تكوين قناة الأسئلة والأجوبة",
  sessionTitle: "عنوان الجلسة",
  descOptional: "الوصف (اختياري)",
  maxQuestions: "الحد الأقصى للأسئلة/المستخدم",
  accessControl: "تحكم الوصول",
  protected: "محمي",
  public: "عام",
  optional: "اختياري",
  requiresPin: "يتطلب رمز PIN",
  requireLogin: "يتطلب تسجيل الدخول عبر Google",
  requireLoginDesc: "يجب على الجمهور تسجيل الدخول عبر Google قبل الانضمام.",
  freeToJoin: "مجان للإنتساب",
  addDescriptionPrompt: "أضف وصفاً لمساعدة الذكاء الاصطناعي على فهم السياق...",
  uploadSlidePrompt: "قم برفع عرض تقديمي لتوجيه جمهورك...",
  uploadSlideBtn: "رفع العرض التقديمي",
  optionalEncouragement: "اختياري، ولكن يوصى به للحصول على نتائج أفضل من الذكاء الاصطناعي.",
  cancel: "إلغاء",
  close: "إغلاق",
  createChannel: "إنشاء قناة",
  joinTitle: "أهلاً بك!",
  joining: "أنت تنضم",
  yourName: "اسمك",
  leaveBlank: "اتركه فارغًا للاستخدام",
  joinBtn: "انضم للجلسة",
  loginRequiredTitle: "سجّل الدخول للانضمام",
  loginRequiredDesc: "تتطلب هذه الجلسة تسجيل الدخول عبر Google قبل الانضمام.",
  continueWithGoogle: "المتابعة باستخدام Google",
  signedInAs: "مسجل الدخول باسم",
  recent: "الأحدث",
  popular: "الأكثر تصويتًا",
  mine: "أسئلتي",
  noQuestions: "لا توجد أسئلة بعد",
  typeQuestion: "اكتب سؤالاً...",
  askingDisabled: "الأسئلة معطلة",
  postAs: "نشر باسم",
  left: "متبقي",
  liveFeed: "بث مباشر",
  analytics: "تحليلات",
  insights: "رؤى الذكاء الاصطناعي",
  exportCSV: "تصدير CSV",
  endSession: "إنهاء الجلسة",
  sessionEnded: "انتهت الجلسة",
  joinCode: "رمز الانضمام",
  showQR: "عرض QR",
  trendingTopics: "مواضيع رائجة",
  engagement: "تفاعل",
  active: "نشط",
  passive: "سلبي",
  aiAnalysisReady: "تحليل AI جاهز",
  generateInsights: "توليد رؤى مباشرة",
  addApiKey: "إضافة مفتاح API",
  removeApiKeyTitle: "إزالة مفتاح API؟",
  removeApiKeyConfirm: "ستتوقف ميزات الذكاء الاصطناعي حتى يتم حفظ مفتاح جديد.",
  removeApiKeyAction: "إزالة المفتاح",
  refreshAnalysis: "تحديث التحليل",
  online: "متصل",
  activeParticipants: "مشاركون نشطون",
  markAnswered: "تمت الإجابة",
  answered: "مجابة",
  hide: "إخفاء",
  unhide: "إظهار",
  favorite: "مفضل",
  pin: "تثبيت في الأعلى",
  analyzing: "جاري التحليل...",
  autoGroup: "تجميع تلقائي",
  checkGrammar: "تدقيق لغوي",
  reanalyze: "إعادة التحليل",
  checking: "جاري التحقق...",
  aiSuggestion: "اقتراح AI",
  applyChange: "تطبيق التغيير",
  dismiss: "تجاهل",
  questions: "أسئلة",
  endSessionConfirmTitle: "إنهاء الجلسة؟",
  endSessionConfirmBody: "سيتم إغلاق الجلسة بشكل دائم.",
  confirmEnd: "نعم، إنهاء",
  sessionUnavailable: "جلسة غير متاحة",
  createError: "فشل إنشاء الجلسة.",
  error: "خطأ",
  sessionEndedMessage: "هذه الجلسة انتهت.",
  backToHome: "عودة للرئيسية",
  aiPriorityEx: "النتيجة تعتمد على القواعد والوضوح.",
  analyticsInsights: "التحليلات والرؤى",
  popularTopics: "المواضيع الشائعة",
  aiConsultant: "مستشار الذكاء الاصطناعي",
  aiConsultantDesc: "تحليل الأسئلة للعثور على الأنماط وتلخيص الجلسة.",
  runAnalysis: "تشغيل التحليل",
  regenerateSummary: "إعادة إنشاء الملخص",
  addApiKeyFirst: "أضف مفتاح API أولاً",
  advancedInsightsComingSoon: "رؤى متقدمة قريباً",
  advancedInsightsDesc: "تحليل أعمق للمشاعر واتجاهات المشاركة.",
  endSessionDesc: "إنهاء الجلسة يسمح لك بجمع التعليقات. لن يتمكن المشاركون من طرح أسئلة جديدة.",
  presentationMode: "وضع العرض",
  startPresentation: "بدء العرض",
  presenting: "جاري العرض",
  noQuestionsFilter: "لا أسئلة لعرضها",
  exitPresentation: "خروج من العرض",
  next: "التالي",
  prev: "السابق",
  shortcuts: "اختصارات",
  markAnsweredShort: "تمت الإجابة",
  keyboardHint: "استخدم الأسهم للتنقل",

  slides: "الشرائح",
  uploadSlides: "رفع شرائح",
  uploadSlidesDesc: "رفع العرض التقديمي لتجميع الأسئلة.",
  uploadBtn: "اختر صور",
  processingSlides: "معالجة...",
  generalQuestions: "عام",
  currentSlide: "الشريحة الحالية",
  setAsCurrent: "تعيين كحالي",
  questionsForSlide: "أسئلة الشريحة",

  softCloseTitle: "ختم الجلسة؟",
  softCloseBody: "يمكنك بدء 'وضع الملاحظات' أو الإنهاء فوراً.",
  startFeedback: "بدء وضع الملاحظات",
  endImmediately: "إنهاء فوراً",
  feedbackMode: "وضع الملاحظات",
  feedbackLive: "الملاحظات مباشرة",
  waitingForFeedback: "بانتظار آراء الجمهور...",
  analyzeSentiment: "تحليل المشاعر",
  reanalyzeSentiment: "إعادة تحليل المشاعر",
  averageRating: "متوسط التقييم",
  netScore: "نتيجة الجلسة",
  archiveSession: "أرشفة وإغلاق",
  rateSession: "قيم هذه الجلسة",
  feedbackPlaceholder: "ما هي الفكرة الرئيسية؟",
  submitFeedback: "إرسال الملاحظات",
  thankYou: "شكراً!",
  aiTakeawayTitle: "ملخص الجلسة",
  aiTakeawayDesc: "قام VoxPop بتحليل الجلسة وإنشاء هذا الملخص.",
  generatingTakeaway: "جاري إنشاء الملخص...",
  generateTakeawayDesc: "قم بإنشاء ملخص موجز للشرائح والأسئلة والأجوبة لجمهورك.",
  generateBtn: "توليد",
  updating: "جاري التحديث...",
  copy: "نسخ",
  feedbackReport: "تقرير الملاحظات",
  exitSession: "خروج",
  remove: "إزالة",

  // Support Requests
  supportCenter: "مركز الدعم",
  supportCenterDesc: "أرسل طلبات الميزات أو تقارير الأخطاء. أرفق الملفات وتتبع الحالة هنا.",
  requestType: "نوع الطلب",
  requestTypeFeature: "طلب ميزة",
  requestTypeBug: "تقرير خطأ",
  requestTitle: "العنوان",
  requestTitlePlaceholder: "ملخص قصير",
  requestDescription: "التفاصيل",
  requestDescriptionPlaceholder: "الخطوات، السلوك المتوقع، والسياق.",
  attachments: "المرفقات",
  submitRequest: "تقديم الطلب",
  submitting: "جاري التقديم...",
  requestStatus: "طلباتك",
  noSupportRequests: "لم يتم تقديم أي طلبات بعد.",
  supportStatusSubmitted: "تم التقديم",
  supportStatusInReview: "قيد المراجعة",
  supportStatusPlanned: "مخطط",
  supportStatusInProgress: "قيد التنفيذ",
  supportStatusResolved: "تم الحل",
  supportStatusRejected: "مرفوض",
  supportFormError: "يرجى إضافة عنوان ووصف.",
  supportSubmitFailed: "فشل تقديم الطلب. يرجى المحاولة مرة أخرى.",
  supportResponseNote: "يمكنك إضافة المزيد من الطلبات في أي وقت.",

  tourMobileSettingsTitle: "الإعدادات والإجراءات",
  tourMobileSettingsDesc: "الوصول إلى إعدادات الجلسة من هنا. يمكنك أيضًا العثور على أزرار رمز الاستجابة السريعة وتصدير CSV وإنهاء الجلسة في هذه القائمة.",
  sessionActions: "إجراءات الجلسة",

  // Landing Page
  heroSubtitle: "Gemini 3 Pro هو مدير الجلسة المباشر.",
  storyHook: "تخيل أنك تسأل 'أي أسئلة؟' والجميع صامت. VoxPop يحل هذا.",
  storyProblemTitle: "المشكلة",
  storyProblemBody: "الجلسات المباشرة فوضوية.",
  storyAudienceTitle: "مسار الجمهور",
  storyAudienceBody: "يمسح الجمهور الرمز، وينضمون بدون تسجيل.",
  storyAITitle: "مدعوم بـ Gemini 3 Pro",
  storyAIBody: "ينظف Gemini القواعد ويصنف المواضيع.",
  storyImpactTitle: "رؤى المقدم",
  storyImpactBody: "يتم تخزين جميع الأسئلة في الوقت الحقيقي.",

  sessionPlaceholder: "مثال: اجتماع الربع الرابع",
  geminiAnalysis: "تحليل Gemini",
  problemHeading: "لماذا الأسئلة المباشرة معطلة",
  frictionlessTitle: "مشاركة سلسة",
  knowAudienceTitle: "اعرف جمهورك",
  high: "عالي",
  featGrammar: "تصحيح قواعد",
  featProfanity: "فلتر الكلمات المسيئة",
  featTopic: "وسم المواضيع",
  featGrouping: "تجميع ذكي",
  mockPricing: "أسعار",
  mockAPI: "API",
  mockSecurity: "أمان",
  footerText: "© 2024 VoxPop AI",
  joinInstruction: "أدخل الكود المكون من 8 أحرف.",
  tapToAsk: "اضغط للأسفل للسؤال!",

  settings: "الإعدادات",
  appearance: "المظهر",
  language: "اللغة",
  theme: "السمة",
  sessionDetails: "تفاصيل الجلسة",
  participation: "المشاركة",
  participants: "المشاركون",
  saveChanges: "حفظ التغييرات",
  saving: "جاري الحفظ...",

  aiFeaturesDisabled: "ميزات الذكاء الاصطناعي معطلة",
  enableAiFeatures: "يرجى إضافة مفتاح API في الإعدادات لتفعيلها.",
  aiWarningTitle: "تحذير الذكاء الاصطناعي",
  aiTokenPreconditionMessage:
    "ميزات الذكاء الاصطناعي غير متاحة مؤقتًا (412). إذا كنت مقدم العرض، فتحقق من مفتاح Gemini API في الإعدادات وتأكد من أنه نشط مع تفعيل الفوترة ثم حاول مرة أخرى.",
  aiQuotaExceededMessage:
    "تم تجاوز حصة الذكاء الاصطناعي أو حد المعدل. يرجى الانتظار قليلًا ثم المحاولة مجددًا أو التحقق من خطة Gemini والفوترة.",
  welcome: "مرحباً",
  setupPrompt: "لنقم بإعداد VoxPop AI.",
  activateAi: "تفعيل",
  activateAiDesc: "يستخدم VoxPop تقنية Gemini.",
  getStarted: "ابدأ الآن",
  enterGeminiKey: "أدخل مفتاح Gemini API",
  keyStoredLocally: "مفتاحك مخزن محلياً ومشفر.",
  needKeyPrompt: "تحتاج مفتاح؟ احصل عليه مجاناً في",
  saveContinue: "حفظ ومتابعة",
  viewPresenter: "مقدم",
  viewAudience: "جمهور",
  loading: "جاري التحميل...",
  incorrectPin: "رمز PIN غير صحيح",
  errorValidatingPin: "خطأ في التحقق من صحة رمز PIN",
  sessionId: "معرف الجلسة",
  sessionIdPlaceholder: "مثل A1B2-C3D4…",

  // FeedbackView
  ratePrompt: "كيف تقيم هذا العرض؟",
  keyTakeaway: "فكرة رئيسية واحدة؟",
  submitSeeCheatSheet: "إرسال وعرض الملخص →",
  submitFeedbackBtn: "إرسال الملاحظات",
  skipStep: "تخطى هذه الخطوة",
  unlocked: "مفتوح",
  generatingAiSummary: "يقوم الذكاء الاصطناعي بتلخيص الجلسة…",
  savedToClipboard: "تم الحفظ في الحافظة!",
  copySummary: "نسخ الملخص",
  screenshotsEncouraged: "نشجع لقطات الشاشة! 📸",
  feedbackSubmitted: "تم إرسال ملاحظاتك بنجاح.",

  // ParticipantList
  onlineCount: "متصل",
  noParticipants: "لا أحد هنا بعد.",
  joinedAt: "انضم في",

  // QuestionCard
  pinned: "مثبت",
  onHold: "قيد الانتظار",
  waitingApproval: "بانتظار الموافقة…",
  rejected: "مرفوض",
  questionBlocked: "تم حظر السؤال: محتوى غير لائق.",
  editedFrom: "معدل من:",
  ownQuestionVoteError: "لا يمكنك التصويت على سؤالك",
  upvoteAria: "تصويت للسؤال، العدد الحالي",
  voteCount: "عدد الأصوات",
  markPending: "تحديد كقيد الانتظار",
  markAnsweredDone: "تحديد كمجاب",
  markDone: "تم",
  markDoneShort: "تحديد كتم",
  removeFromFavorites: "إزالة من المفضلة",
  addToFavorites: "إضافة للمفضلة",
  unpinQuestion: "إلغاء تثبيت السؤال",
  pinQuestion: "تثبيت السؤال",

  // PresenterDashboard & LandingPage
  slideNum: "شريحة",
  supportsFiles: "يدعم الصور (JPG, PNG) و PDF",
  addBtn: "إضافة",
  slideProcessing: "قيد المعالجة",
  deleteSlide: "حذف الشريحة",
  deleteSlideConfirm: "هل تريد حذف هذه الشريحة؟ لا يمكن التراجع عن ذلك.",
  liveIndicator: "مباشر",
  aiReady: "AI جاهز",
  newCount: "جديد",
  unrelatedQuestions: "غير مرتبط بشريحة محددة",
  generalQuestionsDesc: "الأسئلة التي لم يتمكن AI من ربطها بشريحة محددة.",
  archivedStatus: "مؤرشف",
  all: "الكل",
  signOut: "تسجيل الخروج",
  dashboardLabel: "لوحة القيادة",
  signInRequired: "يرجى تسجيل الدخول لتقديم طلب.",
  newSession: "جلسة جديدة",
  joinExisting: "انضمام لموجودة",
  lightTheme: "فاتح",
  darkTheme: "الوضع الداكن",
  auroraEffect: "تأثير الشفق",
  pinCodeLabel: "رمز PIN",
  changesSaved: "تم حفظ التغييرات بنجاح!",
  votesLabel: "أصوات",
  pressEnter: "اضغط Enter",
  enterKey: "Enter",
  confirm: "تأكيد",
  delete: "حذف",
  confirmDelete: "هل أنت متأكد أنك تريد حذف طلب الدعم هذا؟",
  supportDeleteFailed: "فشل حذف الطلب. يرجى المحاولة مرة أخرى.",
  copied: "تم النسخ!",
  idShort: "ID:",
  enterPinPlaceholder: "أدخل PIN المكون من 6 أرقام...",
  confirmAccessControlChange: "تمكين التحكم في الوصول قد يؤدي إلى فصل المشاركين الحاليين. هل أنت متأكد أنك تريد الاستمرار؟",
  smartSuggestion: "اقتراحات ذكية",
  smartSuggestionDesc: "ساعد جمهورك في طرح أسئلة أفضل. يقدم الذكاء الاصطناعي لدينا اقتراحات بناءً على مبدأ الهرم.",
  aiAnalysisPrefix: "تحليل الذكاء الاصطناعي:",
  analyzingSlides: "تحليل الشرائح باستخدام الذكاء الاصطناعي...",
  analyzedSlideProgress: "تم تحليل الشريحة",
  processingFiles: "جاري معالجة الملفات...",
  pdfProcessError: "تعذر معالجة PDF:",
  uploadingProgress: "جاري الرفع",
  noQuestionsSlide: "لا توجد أسئلة لهذه الشريحة بعد.",
  fileTooLarge: "حجم الملف كبير جداً.",
  maxSize: "(بحد أقصى {0} ميجابايت)",
  unsupportedFiles: "بعض الملفات غير مدعومة. المسموح به: {0}",
  filesSelected: "تم اختيار {0} ملفات",
  editProfile: "تعديل الملف الشخصي",
  systemTheme: "النظام",
  auroraEffectDesc: "تأثيرات خلفية ديناميكية",
  buyMeCoffee: "اشتر لي قهوة",
  aiStatusActive: "الذكاء الاصطناعي نشط",
  aiStatusInactive: "الذكاء الاصطناعي غير نشط",
  aiActiveBenefit: "تجميع ذكي وملخصات جاهزة.",
  aiInactiveAction: "أضف مفتاحاً لفتح قوى الذكاء الاصطناعي",
  getKeyLink: "احصل على مفتاح Gemini API مجاني",
  sessionNoAiPower: "ملاحظة: لن تمتلك جلستك قوى الذكاء الاصطناعي لأن API غير مفعل.",
  maxSessionsReached: "لقد وصلت إلى الحد الأقصى لعدد الجلسات. يرجى أرشفة أو حذف الجلسات القديمة.",
  skipFeedback: "تخطي التقييم والإنهاء",
  toggleParticipantList: "تبديل قائمة المشاركين النشطين",
  rateStarAria: "تقييم {0} من 5",
  copyToClipboardAria: "نسخ الملخص إلى الحافظة",
  activeSessionDetected: "تم اكتشاف جلسة نشطة",
  archivePrompt: "لديك جلسة مباشرة حالية. يجب أرشفتها لبدء جلسة جديدة.",
  returnToLiveSessionPrompt: "لديك جلسة مباشرة قيد التنفيذ.",
  archiveAndCreate: "أرشفة وإنشاء",
  archiveAndCreateNew: "أرشفة وإنشاء جديد",
  returnToSession: "العودة إلى الجلسة المباشرة",
  or: "أو",
  copyJoinLink: "نسخ رابط الانضمام",
  anonymous: "مجهول",
  questionLimitReached: "لقد وصلت إلى الحد الأقصى للأسئلة المسموح بها لهذه الجلسة.",
  submitError: "فشل إرسال السؤال. يرجى التحقق من اتصالك.",
  sessionIsLocked: "الجلسة مغلقة",
  sessionLockedAlert: "الجلسة مغلقة. طرح أسئلة جديدة غير مسموح به.",
  liveComments: "تعليقات مباشرة",
  noComment: "لا يوجد تعليق",
  responded: "تم الرد",
  participantsLabel: "مشاركون",
  waitingForComments: "في انتظار التعليقات...",
  liveInsights: "رؤى مباشرة",
  liveInsightsDesc: "احصل على نبض حقيقي لمشاعر الجمهور ومستويات التفاعل أثناء تحدثك.",
  semanticGrouping: "تجميع دلالي",
  semanticGroupingDesc: "عشرة أشخاص سألوا عن العمل عن بعد بصيغ مختلفة؟ يرى VoxPop موضوعاً رئيسياً واحداً.",
  slideSyncDesc: "ارفع شرائح العرض الخاصة بك. يتم وسم الأسئلة تلقائياً بالشريحة التي تظهر على الشاشة.",
  feedbackModeDesc: "اختتم جلستك بطلب التقييمات والأفكار الرئيسية.",
  seeDemo: "مشاهدة العرض التجريبي",
  effortlessTitle: "سهل للجميع",
  createSession: "إنشاء جلسة",
  createSessionDesc: "يقوم المضيف بإعداد القناة في ثوانٍ.",
  audienceJoinsQR: "انضمام الجمهور عبر QR",
  audienceJoinsQRDesc: "لا تحميل تطبيق. لا تسجيل دخول. فقط وجه الكاميرا وابدأ بالسؤال.",
  aiModeratesGroups: "الذكاء الاصطناعي يدير ويجمع",
  aiModeratesGroupsDesc: "تظهر الأسئلة في لوحة تحكم المضيف، منظمة حسب الموضوع والأهمية.",
  readyToEngage: "جاهز للمشاركة؟",
  readyToEngageDesc: "انضم إلى آلاف المحاضرين الذين يستخدمون VoxPop.",
  getStartedFree: "ابدأ مجاناً",
  noCreditCardDesc: "لا حاجة لبطاقة ائتمان. فئة مجانية للأبد.",
  statusLive: "مباشر",
  limitLabel: "الحد",
  howItWorks: "كيف يعمل",
  features: "المميزات",
  presenterLogin: "دخول المحاضر",
  goToDashboard: "الذهاب إلى لوحة التحكم",
  newPresentationMode: "جديد: وضع العرض التقديمي التفاعلي",
  superchargedByGemini: "مدعوم من Gemini 3 Pro",
  aiEngineDesc: "نحن لا نجمع الأسئلة فقط. نحن نفهمها.",
  createSessionBtn: "إنشاء جلسة",
  feedbackLocked: "التقييم مقفل",
  feedbackLockedDesc: "ابدأ وضع التقييم للسماح للجمهور بتقييم الجلسة.",
  finalResults: "النتائج النهائية",
  startFeedbackMode: "بدء وضع التقييم",

  // User Dashboard
  myDashboard: "لوحة التحكم الخاصة بي",
  profile: "الملف الشخصي",
  sessionHistory: "سجل الجلسات",
  updateProfile: "تحديث الملف الشخصي",
  displayName: "اسم العرض",
  photoUrl: "رابط الصورة",
  saveProfile: "حفظ الملف الشخصي",
  profileUpdated: "تم تحديث الملف الشخصي بنجاح",
  noSessions: "لم يتم العثور على جلسات",
  createFirstSession: "أنشئ جلستك الأولى للبدء!",
  viewSession: "عرض الجلسة",
  sessions: "الجلسات",
  joined: "انضم",
  created: "تم الإنشاء",

  // New Dashboard Keys
  welcomeBack: "مرحباً بعودتك",
  totalSessions: "الجلسات",
  activeSessions: "جلسات نشطة",
  yourSessions: "جلساتك",
  manageSessionsSubtitle: "إدارة ومراقبة قنوات تعليقات الجمهور",
  readyToStart: "جاهز للبدء؟",
  creating: "جارٍ الإنشاء",
  logout: "تسجيل الخروج",
  errorArchiving: "خطأ في أرشفة الجلسة",
  errorUploadingSlide: "خطأ في تحميل الشريحة. تم إنشاء الجلسة بدونها.",
  geminiApiKey: "مفتاح واجهة برمجة تطبيقات Gemini",
  geminiApiKeyPlaceholder: "أدخل مفتاح واجهة برمجة تطبيقات Gemini الخاص بك",
  geminiPrivacyNote: "يتم تخزين مفتاحك محليًا في متصفحك ولا يتم إرساله أبدًا إلى خوادمنا.",
  backToDashboard: "العودة إلى لوحة القيادة",
  manageYourSettings: "إدارة التفضيلات العامة وتكوين الذكاء الاصطناعي",
  appPreferences: "تفضيلات التطبيق",
  aiConfigurationMoved: "تم نقل تكوين الذكاء الاصطناعي",
  aiConfigurationMovedDesc: "أصبحت إعدادات Gemini AI الآن عالمية. يمكنك إدارة مفتاح API الخاص بك لجميع الجلسات في مكان واحد.",
  goToUserSettings: "انتقل إلى إعدادات المستخدم",
  manageAiKeysInSettings: "إدارة مفاتيح Gemini API في الإعدادات العامة",
  goToSettings: "انتقل إلى الإعدادات",
  aiConfiguration: "تكوين الذكاء الاصطناعي",
  sessionEndedReadOnly: "انتهت الجلسة (للقراءة فقط)",

  // Tour
  tourViewSwitcherTitle: "مبدل العرض",
  tourViewSwitcherDesc: "التنقل بين عرض المقدم (لوحة القيادة) وعرض الجمهور (ما يراه المستخدمون).",
  tourLiveFeedTitle: "البث المباشر",
  tourLiveFeedDesc: "مراقبة الأسئلة الواردة من الجمهور في الوقت الفعلي. يمكنك تفضيلها، أو تثبيتها، أو تعليمها كمجابة.",
  tourSlideSyncTitle: "مزامنة الشرائح",
  tourSlideSyncDesc: "ارفع شرائح العرض التقديمي لتجميع الأسئلة الواردة تلقائياً حسب الشريحة.",
  tourAiInsightsTitle: "رؤى الذكاء الاصطناعي",
  tourAiInsightsDesc: "استخدم Gemini 3 Pro لإنشاء ملخصات، وتحليل المشاعر، واكتشاف المواضيع الرائجة فوراً.",
  tourFeedbackLoopTitle: "حلقة الملاحظات",
  tourFeedbackLoopDesc: "عند إنهاء جلستك، انتقل إلى هذه التبويبة لجمع تقييمات الجمهور والنتائج الرئيسية قبل الإغلاق.",
  tourSettingsTitle: "الإعدادات ومفتاح API",
  tourSettingsDesc: "قم بتكوين خيارات الجلسة وإدخال مفتاح Gemini API هنا لتفعيل ميزات الذكاء الاصطناعي.",
  tourJoinCodeTitle: "رمز الانضمام",
  tourJoinCodeDesc: "انقر هنا لإظهار رمز QR ومعرف الجلسة لينضم جمهورك.",

  // CSV Export
  author: "المؤلف",
  text: "النص",
  topic: "الموضوع",
  upvotes: "الأصوات",
  status: "الحالة",
  timestamp: "الطابع الزمني",
};

export const translations = {
  en,
  es,
  fr,
  zh,
  hi,
  vi,
  ar,
} as const;
